import React, { Component } from 'react';
import { Grid, Button, Typography, Box, Dialog, DialogActions, DialogContent, DialogTitle, Checkbox, FormControlLabel } from '@material-ui/core';
import '../CSS/NewReservation.css';
import {
    getTaxes, makeReservation, getCardType, recordPayment, cardConnectPaymemt, insertCamperCard,
    getSiteTaxes, addVariableCharge, addExtras, getIntegrations, getEmailTemplates, sendMail, getEmails,
    getCampers, cardConnectGetListOfTerminals, cardConnectConnectToTerminal, cardConnectTerminalPayment,
    addSystemFeeRecord, getRemoteReservationsStatus, getVariableRatesStatus, getAllseasons, getReplayID, updateReplayID, getPaymentMethod
} from '../utils/OpenCampground_Database_Calls'
import { makePayment, makeVaultedPayment, getJWTToken, getListOfTerminals, createTerminalPayment, getTerminalTransaction } from '../utils/MxMerchant_Services'
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { format, differenceInCalendarDays, addDays, isBefore, isAfter, min, max } from 'date-fns'; import { createTheme, ThemeProvider } from '@mui/material/styles';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import reservationConfirmation from '../assets/reservation_confirm.png'
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import GroupIcon from '@mui/icons-material/Group';
import PetsIcon from '@mui/icons-material/Pets';
import DateRangeIcon from '@mui/icons-material/DateRange';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PersonIcon from '@mui/icons-material/Person';
import KeyIcon from '@mui/icons-material/Key';
import TodayIcon from '@mui/icons-material/Today';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Autocomplete, createFilterOptions } from '@mui/material';
import { CircularProgress } from '@material-ui/core';
import { styled } from '@mui/material/styles';
import rv from '../assets/RV.png'
import measuring from '../assets/measuring.png'
import { Select, MenuItem } from '@mui/material';
import StripePayment from './StripePayment';

const useStyles = theme => ({
    circularProgress: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        color: '#2dcd7a'
    },
    dialogPaper: {
        padding: theme.spacing(2),
        borderRadius: '10px',
    }
});

const theme = createTheme({
    palette: {
        primary: {
            main: '#2dcd7a',
        },
    }
});

const GreenCheckbox = styled(Checkbox)({
    color: '#000000',
    '&.Mui-checked': {
        color: '#2dcd7a',
    },
});

const methods =["Bank Transfer", "Wire Transfer", "Venmo", "PayPal", "Zelle", "Apple Pay", "Google Pay", "Gift Card", "Square", "Others"]

const toUTCDateOnly = function(dateString) {
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day);
  };
const offsetMinutes = new Date().getTimezoneOffset();
class NewReservationUserDetails extends Component {
    constructor(props) {
        super(props);
        this.addExtra = this.addExtra.bind(this);
        this.state = {
            userDetails: true,

            //userDetails
            fname: '',
            lname: '',
            emailId: '',
            phoneNumber: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            counts: [],
            guests: [],
            internalNotes: '',
            userDetailsFormValid: false,

            //pricing
            days: '',
            weeks: '',
            months: '',
            season: '',
            daysTotal: '',
            weeksTotal: '',
            monthsTotal: '',
            seasonTotal: '',
            subTotal: '',
            subTotalWithoutDiscount: '',
            taxes: [],
            totalAmount: '',
            tax: [],
            taxPercent: [],
            taxName: [],
            convenienceCharge: null,
            baseTotal: 0.0,
            selectedExtras: [],
            selectedExtraAmount: [],
            selectedExtraCount: [],
            extraId: [],
            extraSubTotal: 0,
            selectedPaymentValue: '',
            partialTotal: 0.0,
            balance: 0.0,
            partialBase: '',
            cardNumber: '',
            cardOwner: '',
            expiryMonth: '',
            expiryYear: '',
            cvv: '',
            convenienceFees: '',
            ccPOSAmount: '',
            useVariable: false,
            variableCharges: [],
            newVariableChargeName: '',
            newVariableChargeAmount: null,
            taxable: true,

            //addOns
            start: [],
            end: [],
            type2Add: false,

            //popup
            open: false,
            popupText: '',
            open1: false,
            popupText1: '',

            //paymentIntegrations
            paymentIntegration: [],

            //email
            remoteResReceivedMailMessage: '',
            remoteReservationReceivedSubject: '',
            remoteResReceivedAttachments: [],
            sender: '',
            reply: '',
            cc: '',
            bcc: '',
            cashDate: format(new Date(), 'MM/dd/yyyy'),
            cashAmount: '',
            checkAmount: '',
            checkNumber: '',
            memo: '',
            checkDate: format(new Date(), 'MM/dd/yyyy'),
            discountTotal: null,
            oneTimeDiscount: 0.00,
            originalSubTotal: '',
            camperId: null,
            discountByPercent: false,
            amountPaid: '',
            waitForCalculations: true,
            open2: false,
            last4: null,
            paymentToken: null,
            payWithSavedCard: false,
            saveCard: false,
            daySpecificRatesStatus: '',
            dayChunks: [],
            blended: false,
            monthChunks: [],
            weekChunks: [],
            offlineAmount: null,
            offlineMethod: null,
            offlineMemo: '',
            offlineLast4: null,
            offlinePaymentDate: null,
        };
    }

    async componentDidMount() {
        this.getGuests()
        let paymentIntegration = await getIntegrations(this.props.user, this.props.serverName)
        console.log("paymentIntegration: ", paymentIntegration)
        let mailMessages = await getEmailTemplates(this.props.user, this.props.serverName)
        console.log("Mail messages: ", mailMessages)
        let remoteActive = await getRemoteReservationsStatus(this.props.user, this.props.serverName);
        let email = await getEmails(this.props.user, this.props.serverName)
        console.log("email: ", email)
        let seasons = await getAllseasons(this.props.user, this.props.serverName, this.props.checkIn, this.props.checkOut, this.props.spaceName)
        // let monthDate = new Date(this.props.checkIn);
        let monthDate = offsetMinutes > 0? toUTCDateOnly(this.props.checkIn): new Date(this.props.checkIn);
        const daySpecificRatesStatus = await getVariableRatesStatus(this.props.user, this.props.serverName)
        this.setState({
            paymentIntegration: paymentIntegration
        })
        let monthChunks = [];
        let weekChunks = [];
        let dayChunks = [];
        if (seasons.length > 1) {
            this.setState({
                blended: true
            })
        }
        //calculate total
        let term = this.getDuration(this.props.checkIn, this.props.checkOut);
        const daySpecificRates = {
            0: this.props.sunday,
            1: this.props.monday,
            2: this.props.tuesday,
            3: this.props.wednesday,
            4: this.props.thursday,
            5: this.props.friday,
            6: this.props.saturday
        };
        console.log("days: ", term[0])
        console.log("weeks: ", term[1])
        console.log("months: ", term[2])
        let subTotal = 0.0;
        let subTotalWithoutDiscount = 0.0;
        let seasonTotal = 0.0;
        let monthsTotal = 0;
        let weeksTotal = 0;
        let daysTotal = 0;
        let discountTotal = null;
        if (this.props.seasonBooking) {
            seasonTotal = this.props.seasonal
            subTotal += seasonTotal;
            subTotalWithoutDiscount += seasonTotal;
        } else {
            // if (term[2] > 0) {
            //     if (this.props.monthly > 0) {
            //         monthsTotal = (term[2] * this.props.monthly);
            //         subTotal += monthsTotal;
            //         subTotalWithoutDiscount += monthsTotal;
            //     } else {
            //         let totalDaysFromMonths = 0;
            //         for (let i = 0; i < term[2]; i++) {
            //             let monthDate = new Date(this.props.checkIn);
            //             monthDate.setMonth(monthDate.getMonth() + i);
            //             const monthDays = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0).getDate();
            //             totalDaysFromMonths += monthDays;
            //         }
            //         // term[1] = term[1] + (totalDaysFromMonths / 7);
            //         // term[2] = 0;
            //         const weeksFromMonths = Math.floor(totalDaysFromMonths / 7);
            //         const leftoverDays = totalDaysFromMonths % 7;
            //         term[1] += weeksFromMonths;
            //         term[0] += leftoverDays;
            //         term[2] = 0;
            //     }
            // }
            // if (term[1] > 0) {
            //     if (this.props.weekly > 0) {
            //         weeksTotal = ((term[1]) * this.props.weekly);
            //         subTotal += weeksTotal;
            //         subTotalWithoutDiscount += weeksTotal;
            //     } else {
            //         term[0] = term[0] + (term[1] * 7);
            //         term[1] = 0
            //     }
            // }
            // if (term[0] > 0) {
            //     if(daySpecificRatesStatus){
            //     let checkInDate = new Date(this.props.checkIn);
            //     let daysToAdvance = 0;
            //     let baseDate = new Date(this.props.checkIn);
            //     for (let i = 0; i < term[2]; i++) {
            //         let monthDate = new Date(baseDate);
            //         monthDate.setMonth(monthDate.getMonth() + i);
            //         let year = monthDate.getFullYear();
            //         let month = monthDate.getMonth();
            //         let daysInMonth = new Date(year, month + 1, 0).getDate();
            //         daysToAdvance += daysInMonth;
            //     }
            //     checkInDate.setDate(checkInDate.getDate() + daysToAdvance);
            //     for (let i = 0; i < term[0]; i++) {
            //         const dayOfWeek = checkInDate.getUTCDay();
            //         console.log('the day of thee week', dayOfWeek);
            //         const dayspecificrate = daySpecificRates[dayOfWeek] ?? this.props.daily ?? 0;
            //         console.log(`the day of thee week ${dayOfWeek} and its price ${dayspecificrate} ${this.props.sunday} ${this.props.Saturday}`);
            //         daysTotal += dayspecificrate;
            //         subTotal += dayspecificrate;
            //         subTotalWithoutDiscount += dayspecificrate;
            //         checkInDate.setDate(checkInDate.getDate() + 1);
            //     }}
            //     else{
            //     daysTotal = (Math.round(term[0]) * this.props.daily);
            //     subTotal += daysTotal;
            //     subTotalWithoutDiscount += daysTotal;
            //     }
            // }
            if (term[2]) {
                let monthEndDate = new Date(monthDate);
                monthEndDate.setMonth(monthEndDate.getMonth() + term[2]);
                // monthDate.setMonth(monthDate.getMonth() + term[2]); 
                monthChunks = this.calculateReservationCost(monthDate, monthEndDate, seasons, term[2])
                monthsTotal = monthChunks.monthsTotal;
                subTotal += monthChunks.monthsTotal;
                subTotalWithoutDiscount += monthChunks.monthsTotal;
                monthDate.setMonth(monthDate.getMonth() + term[2]);
                console.log(JSON.stringify(monthChunks));
            }
            if (term[1]) {
                let weekEndDate = new Date(monthDate);
                weekEndDate.setDate(monthDate.getDate() + term[1] * 7);
                weekChunks = this.calculateWeeklyReservationCost(monthDate, weekEndDate, seasons)
                weeksTotal = weekChunks.weeksTotal
                subTotal += weekChunks.weeksTotal;
                subTotalWithoutDiscount += weekChunks.weeksTotal
                monthDate.setDate(monthDate.getDate() + term[1] * 7);
                console.log(JSON.stringify(weekChunks));
            }
            if (term[0]) {
                let endDate = new Date(this.props.checkOut);
                dayChunks = this.calculateDailyReservationCost(monthDate, endDate, seasons, daySpecificRatesStatus)
                daysTotal = dayChunks.daysTotal;
                subTotal += dayChunks.daysTotal;
                subTotalWithoutDiscount += dayChunks.daysTotal
                console.log(JSON.stringify(dayChunks));
            }
        }
        console.log("Subtotal: ", subTotal)
        if (this.props.discount != null) {
            if (this.props.discountAmountOnce > 0) {
                discountTotal = this.props.discountAmountOnce
            } else if (this.props.discountAmountDaily > 0 || this.props.discountAmountWeekly > 0 || this.props.discountAmountMonthly > 0) {
                if (term[2] > 0 && this.props.discountAmountMonthly > 0) {
                    discountTotal += (term[2] * this.props.discountAmountMonthly)
                }
                if (term[1] > 0 && this.props.discountAmountWeekly > 0) {
                    discountTotal += (term[1] * this.props.discountAmountWeekly)
                }
                if (term[0] > 0 && this.props.discountAmountDaily > 0) {
                    discountTotal += (term[0] * this.props.discountAmountDaily)
                }
            } else {
                if (monthsTotal > 0 && this.props.monthlyDiscount) {
                    discountTotal += (monthsTotal * this.props.discountPercent) / 100
                }
                if (weeksTotal > 0 && this.props.weeklyDiscount) {
                    discountTotal += (weeksTotal * this.props.discountPercent) / 100
                }
                if (daysTotal > 0 && this.props.dailyDiscount) {
                    discountTotal += (daysTotal * this.props.discountPercent) / 100
                }
                this.setState({
                    discountByPercent: true
                })
            }
            subTotal -= discountTotal
            subTotalWithoutDiscount -= discountTotal;
        }
        console.log("Discounted Value: ", discountTotal)
        this.setState({
            days: term[0],
            weeks: term[1],
            months: term[2],
            season: this.props.seasonBooking ? '1' : '0',
            subTotal: subTotal,
            originalSubTotal: subTotal,
            subTotalWithoutDiscount: subTotalWithoutDiscount,
            seasonTotal: seasonTotal,
            monthsTotal: monthsTotal,
            weeksTotal: weeksTotal,
            daysTotal: daysTotal,
            paymentIntegration: paymentIntegration,
            selectedPaymentValue: paymentIntegration.name === 'None' ? 'cash' : 'fullPayment',
            remoteResReceivedMailMessage: mailMessages[0].body,
            remoteReservationReceivedSubject: email.confirm_subject,
            remoteResReceivedAttachments: mailMessages[0].attachments,
            sender: email.sender,
            reply: email.reply,
            cc: email.cc,
            bcc: email.bcc,
            discountTotal: discountTotal,
            convenienceFees: paymentIntegration.credit_charges * 100,
            useVariable: remoteActive[0].use_variable_charge === 1 ? true : false,
            daySpecificRatesStatus: daySpecificRatesStatus,
            monthChunks: monthChunks.chunks,
            weekChunks: weekChunks.chunks,
            dayChunks: dayChunks.chunks
        })
        this.calculateTaxAndTotal(subTotal, term, 0);
    }

    getGuests = async () => {
        try {
            let listOfGuests = await getCampers(this.props.user, this.props.serverName);
            this.setState({
                guests: listOfGuests
            });
        } catch (error) {
            console.error("Error fetching guests:", error);
        }

    }

    // getDuration(checkIn, checkOut) {
    // const startDate = new Date(checkIn);
    // const endDate = new Date(checkOut);
    // endDate.setDate(endDate.getDate() + 1);
    // let months = 0, weeks = 0, days = 0;
    // let tempDate = new Date(startDate);
    // while (tempDate <= endDate) {
    //     const nextMonth = new Date(tempDate);
    //     nextMonth.setMonth(tempDate.getMonth() + 1);

    //     if (nextMonth <= endDate) {
    //         months++;
    //         tempDate = nextMonth;
    //     } else {
    //         break;
    //     }
    // }
    // const remainingDaysAfterMonths = Math.floor((endDate - tempDate) / (24 * 60 * 60 * 1000));
    // weeks = Math.floor(remainingDaysAfterMonths / 7);
    // days = remainingDaysAfterMonths % 7;

    // return [days, weeks, months];
    //}

    offlineMethodChange = (event) => {
        this.setState({offlineMethod: event.target.value},() => { this.userDetailsValidation() })
    };

    toUTCDateOnly2 = (dateString) => {
        const date = new Date(dateString);
        return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
    }


    getDuration(checkIn, checkOut) {
        console.log(checkIn,checkOut,'before change');
        // const startDate = new Date(checkIn);
        // const endDate = new Date(checkOut);
        const startDate = this.toUTCDateOnly2(checkIn);
        const endDate = this.toUTCDateOnly2(checkOut);
        let months = 0, weeks = 0, days = 0; 
        let tempDate = new Date(startDate);

        while (true) {
            const nextMonth = new Date(Date.UTC(tempDate.getUTCFullYear(), tempDate.getUTCMonth() + 1, tempDate.getUTCDate()));
            if (nextMonth <= endDate) {
                months++;
                tempDate = nextMonth;
            } else {
                break;
            }
        }

        const remainingDays = Math.floor((endDate - tempDate) / (24 * 60 * 60 * 1000));
        weeks = Math.floor(remainingDays / 7);
        days = remainingDays % 7;

        return [days, weeks, months];
    }

    getAverageMonthDays(from, to, monthsCount) {
        const fromDate = new Date(from);

        // If only one month, return the number of days in the 'from' month
        if (monthsCount <= 1) {
            const year = fromDate.getFullYear();
            const month = fromDate.getMonth();
            return new Date(year, month + 1, 0).getDate();
        }

        // Otherwise, calculate the average days per month in the range
        let totalMonthDays = 0;
        let count = 0;
        let current = new Date(fromDate);

        while (current < to) {
            const year = current.getFullYear();
            const month = current.getMonth();
            const daysInMonth = new Date(year, month + 1, 0).getDate();

            totalMonthDays += daysInMonth;
            count++;

            // Move to next month
            current = new Date(year, month + 1, 1);
        }

        return count > 0 ? totalMonthDays / count : 30;
    }

    calculateReservationCost(reservationStart, reservationEnd, seasons, monthsCount) {
        let monthsTotal = 0;
        seasons = seasons.filter(s => s.applies_to_monthly);
        const boundaries = new Set();

        // Ensure all dates are Date objects
        reservationStart = new Date(reservationStart);
        reservationEnd = new Date(reservationEnd);

        // Find boundaries based on season overlaps
        seasons.forEach(season => {
            const start = new Date(season.season_start);
            const end = addDays(new Date(season.season_end), 1); // inclusive

            if (isBefore(end, reservationStart) || isAfter(start, reservationEnd)) return;

            boundaries.add(max([reservationStart, start]).toISOString().split('T')[0]);
            boundaries.add(min([reservationEnd, end]).toISOString().split('T')[0]);
        });

        // Add reservation start and end to ensure full coverage
        boundaries.add(reservationStart.toISOString().split('T')[0]);
        boundaries.add(reservationEnd.toISOString().split('T')[0]);

        const sortedBoundaries = Array.from(boundaries)
            .map(d => offsetMinutes > 0? toUTCDateOnly(d):new Date(d))
            .sort((a, b) => a - b);

        const chunks = [];

        for (let i = 0; i < sortedBoundaries.length - 1; i++) {
            const from = sortedBoundaries[i];
            const to = sortedBoundaries[i + 1];

            if (differenceInCalendarDays(to, from) <= 0) continue;

            const applicableSeasons = seasons.filter(season => {
                const seasonStart = new Date(season.season_start);
                const seasonEndInclusive = addDays(new Date(season.season_end), 1);
                return from < seasonEndInclusive && to > seasonStart;
            });

            const season = applicableSeasons.sort(
                (a, b) =>
                    (new Date(a.season_end) - new Date(a.season_start)) -
                    (new Date(b.season_end) - new Date(b.season_start))
            )[0] || seasons.find(s => s.season_id === 1); // fallback

            const days = differenceInCalendarDays(to, from);
            //   const months = days / 30;
            const avgMonthDays = this.getAverageMonthDays(from, to, monthsCount);
            const months = days / avgMonthDays;
            const cost = parseFloat((months * season.monthly_rate).toFixed(2));
            monthsTotal += cost;

            if (cost == 0) {
                this.setState({
                    dayChunks: [...this.state.dayChunks, { from: from, to: to, days: days, seasonName: season.season_name, seasonId: season.season_id }]
                })
            }
            else {
                chunks.push({
                    from: format(new Date(sortedBoundaries[i]), 'MMM d, yy'),
                    to: format(new Date(sortedBoundaries[i + 1]), 'MMM d, yy'),
                    days,
                    months: months.toFixed(3),
                    season: season.season_name,
                    cost,
                });
            }
        }

        return { chunks, monthsTotal };
    }

    calculateWeeklyReservationCost(reservationStart, reservationEnd, seasons) {
        console.log(reservationStart, reservationEnd);
        let weeksTotal = 0;
        seasons = seasons.filter(s => s.applies_to_weekly);
        const boundaries = new Set();

        seasons.forEach(season => {
            const start = new Date(season.season_start);
            const end = new Date(season.season_end);
            if (isBefore(end, reservationStart) || isAfter(start, reservationEnd)) return;

            boundaries.add(max([reservationStart, start]).toISOString().split('T')[0]);
            boundaries.add(min([reservationEnd, new Date(end.getTime() + 86400000)]).toISOString().split('T')[0]); // inclusive
        });

        boundaries.add(reservationStart.toISOString().split('T')[0]);
        boundaries.add(reservationEnd.toISOString().split('T')[0]);

        const sortedBoundaries = Array.from(boundaries).sort();
        const chunks = [];

        for (let i = 0; i < sortedBoundaries.length - 1; i++) {
            const from = offsetMinutes > 0? toUTCDateOnly(sortedBoundaries[i]):new Date(sortedBoundaries[i]);
            const to = offsetMinutes > 0? toUTCDateOnly(sortedBoundaries[i+1]):new Date(sortedBoundaries[i+1]);
            // const from = format(new Date(sortedBoundaries[i]), 'MMM d, yy');
            // const to = format(new Date(sortedBoundaries[i + 1]), 'MMM d, yy');
            if (differenceInCalendarDays(to, from) <= 0) continue;

            //   const applicableSeasons = seasons.filter(season => {
            //     const seasonStart = new Date(season.season_start);
            //     const seasonEnd = new Date(season.season_end);
            //     return from <= seasonEnd && to >= seasonStart; // Overlap allowed
            //   });
            const applicableSeasons = seasons.filter(season => {
                const seasonStart = new Date(season.season_start);
                const seasonEndInclusive = addDays(new Date(season.season_end), 1);
                return from < seasonEndInclusive && to > seasonStart;
            });
            //   console.log(`applicableSeasons for ${sortedBoundaries[i]} to ${sortedBoundaries[i + 1]} are ${JSON.stringify(applicableSeasons)}`);

            const season = applicableSeasons.sort((a, b) =>
                (new Date(a.season_end) - new Date(a.season_start)) -
                (new Date(b.season_end) - new Date(b.season_start))
            )[0] || seasons.find(s => s.season_id === 1);

            const days = differenceInCalendarDays(to, from);
            const weeks = days / 7;
            const cost = parseFloat((weeks * season.weekly_rate).toFixed(2));
            weeksTotal += cost;

            if (cost == 0) {
                this.setState({
                    dayChunks: [...this.state.dayChunks, { from: from, to: to, days: days, seasonName: season.season_name, seasonId: season.season_id }]
                })
            }
            else {
                chunks.push({
                    from: format(offsetMinutes > 0? toUTCDateOnly(sortedBoundaries[i]):new Date(sortedBoundaries[i]), 'MMM d, yy'),
                    to: format(offsetMinutes > 0? toUTCDateOnly(sortedBoundaries[i+1]):new Date(sortedBoundaries[i+1]), 'MMM d, yy'), 
                    days,
                    weeks: weeks.toFixed(3),
                    season: season.season_name,
                    cost
                });
            }
        }

        return { chunks, weeksTotal };
    }

    calculateDailyReservationCost(reservationStart, reservationEnd, seasons, daySpecificRatesStatus) {
        const chunks = [];
        console.log(this.state.dayChunks);
        let daysTotal = 0;

        this.state.dayChunks.forEach(chunk => {
            let currentDate = new Date(chunk.from);
            const toDate = new Date(chunk.to);
            const season = seasons.find(s => s.season_id === chunk.seasonId);
            if (!season) return;

            while (currentDate < toDate) {
                const nextDate = addDays(currentDate, 1);
                const dayIndex = currentDate.getDay();
                const dayMap = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

                let cost = daySpecificRatesStatus ? (season[dayMap[dayIndex]] || 0) : (season.daily_rate || 0);
                daysTotal += cost;

                chunks.push({
                    //   from: new Date(currentDate),
                    //   to: new Date(nextDate),
                    from: format(currentDate, 'MMM d, yy'),
                    to: format(nextDate, 'MMM d, yy'),
                    day: currentDate.toDateString(),
                    season: season.season_name,
                    cost
                });

                currentDate = nextDate;
            }
        });

        // Now handle main direct range
        let currentDate = new Date(reservationStart);
        const endDate = new Date(reservationEnd);

        while (currentDate < endDate) {
            const nextDate = addDays(currentDate, 1);

            const applicableSeasons = seasons.filter(season =>
                currentDate >= new Date(season.season_start) && currentDate <= new Date(season.season_end)
            );

            let season = applicableSeasons.sort(
                (a, b) =>
                    (new Date(a.season_end) - new Date(a.season_start)) -
                    (new Date(b.season_end) - new Date(b.season_start))
            )[0] || seasons.find(s => s.season_id === 1);

            const dayIndex = currentDate.getDay();
            const dayMap = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

            let cost = daySpecificRatesStatus ? (season[dayMap[dayIndex]] || 0) : (season.daily_rate || 0);
            daysTotal += cost;

            chunks.push({
                // from: new Date(currentDate),
                // to: new Date(nextDate),
                from: format(currentDate, 'MMM d, yy'),
                to: format(nextDate, 'MMM d, yy'),
                day: currentDate.toDateString(),
                season: season.season_name,
                cost
            });

            currentDate = nextDate;
        }

        return { chunks, daysTotal };
    }

    calculateTaxAndTotal = async (subTotal, term, additionalAmount) => {
        let taxes = await getTaxes(this.props.user, this.props.serverName);
        let selectedTaxes = await getSiteTaxes(this.props.user, this.props.serverName, this.props.siteTypeId)
        // console.log(JSON.stringify(selectedTaxes[0].taxrate_ids.split(',').map(id => Number(id.trim())))+'this is the response for the site tax api');
        selectedTaxes = selectedTaxes[0]?.taxrate_ids ? selectedTaxes[0].taxrate_ids.split(',').map(id => Number(id.trim())) : [];
        if (!Array.isArray(selectedTaxes)) selectedTaxes = [];
        let totalAmount = 0.0;
        let tax = [];
        let taxPercent = [];
        let taxName = [];
        let convenienceFees = 0.0;
        let baseTotal = 0.0;
        let variableChargeTotal = 0.0;
        //taxes
        for (let index = 0; index < taxes.length; index++) {
            if (!selectedTaxes.includes(taxes[index].id))
                continue;
            const element = taxes[index];
            if (element.is_percent === 1) {
                let countedTax = 0.0;
                const formula = (element.percent / 100)
                if (element.apl_daily === 1 && this.state.daysTotal > 0) {
                    const total = this.state.daysTotal
                    countedTax += parseFloat((total * formula).toFixed(2));
                }
                if (element.apl_week === 1 && this.state.weeksTotal > 0) {
                    const total = this.state.weeksTotal
                    countedTax += parseFloat((total * formula).toFixed(2));
                }
                if (element.apl_month === 1 && this.state.monthsTotal > 0) {
                    const total = this.state.monthsTotal
                    countedTax += parseFloat((total * formula).toFixed(2));
                }
                if (element.apl_seasonal === 1 && this.state.seasonTotal > 0) {
                    const total = this.state.seasonTotal
                    countedTax += parseFloat((total * formula).toFixed(2));
                }
                if (countedTax > 0) {
                    if (additionalAmount > 0) {
                        const total = additionalAmount
                        countedTax += parseFloat((total * formula).toFixed(2));
                    }
                    if (this.state.discountTotal > 0) {
                        const total = this.state.discountTotal
                        countedTax -= parseFloat((total * formula).toFixed(2));
                    }
                    for (let index = 0; index < this.state.variableCharges.length; index++) {
                        if (this.state.variableCharges[index].taxable)
                            countedTax += parseFloat((this.state.variableCharges[index].amount * formula).toFixed(2));
                    }
                    taxPercent[index] = element.percent;
                    tax[index] = countedTax.toFixed(2);
                    taxName[index] = element.name;
                }
            } else {
                let totalDays = term[0];
                if (element.apl_month === 1) {
                    if (element.monthly_charge_daily === 1) {
                        totalDays = totalDays + (term[2] * 30)
                    } else {
                        taxPercent[index] = element.amount;
                        tax[index] = (term[2] * element.amount)
                        taxName[index] = element.name;
                    }
                } else if (element.apl_week === 1) {
                    if (element.weekly_charge_daily === 1) {
                        totalDays = totalDays + (term[1] * 7)
                    } else {
                        taxPercent[index] = element.amount;
                        tax[index] = (term[1] * element.amount)
                        taxName[index] = element.name;
                    }
                }
                taxPercent[index] = element.amount;
                tax[index] = (totalDays * element.amount)
                taxName[index] = element.name;
            }
        }
        totalAmount = subTotal;
        for (let index = 0; index < tax.length; index++) {
            if (tax[index] !== undefined) {
                totalAmount += parseFloat(tax[index]);
            }
        }
        baseTotal = totalAmount
        if (this.state.variableCharges.length > 0) {
            for (let index = 0; index < this.state.variableCharges.length; index++) {
                variableChargeTotal += parseFloat(this.state.variableCharges[index].amount);
            }
        }
        if ((this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o') && this.state.selectedPaymentValue === 'fullPayment') {
            convenienceFees = (totalAmount.toFixed(2) * this.state.convenienceFees / 100);
        }

        this.setState({
            taxes: taxes,
            totalAmount: parseFloat(totalAmount.toFixed(2)) + parseFloat(variableChargeTotal.toFixed(2)),
            tax: tax,
            taxPercent: taxPercent,
            taxName: taxName,
            convenienceCharge: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? convenienceFees.toFixed(2) : null,
            baseTotal: baseTotal.toFixed(2),
            waitForCalculations: false,
            // subTotal:subTotal
        })
    }

    userDetailsChange = (event) => {
        if (event.target.id === 'phoneNumber') {
            const numericValue = event.target.value.replace(/[^0-9]/g, '');
            this.setState({
                [event.target.id]: numericValue
            }, () => {
                this.userDetailsValidation();
            });
        } else {
            this.setState({
                [event.target.id]: event.target.value
            }, () => {
                this.userDetailsValidation();
            })
        }
    }

    getDays = () => {
        const msPerDay = 24 * 60 * 60 * 1000;
        const startDate = new Date(this.props.checkIn);
        const endDate = new Date(this.props.checkOut);
        let totalDays = Math.floor((endDate - startDate) / msPerDay);
        return totalDays;
    }

    addExtra = (extra, count, index) => {
        let extraTotal = 0;
        let totalDays = this.getDays();
        let duration = this.getDuration(this.props.checkIn, this.props.checkOut)
        let finalCount
        let extraAmount = 0;

        if (extra.extra_type === 0) {
            let tempTotal = 0
            if (duration[2] > 0) {
                tempTotal = tempTotal + (duration[2] * extra.monthly)
            }
            if (duration[1] > 0) {
                tempTotal = tempTotal + (duration[1] * extra.weekly)
            }
            if (duration[0]) {
                tempTotal = tempTotal + (duration[0] * extra.daily);
            }
            extraTotal = tempTotal
            finalCount = totalDays
            extraAmount = tempTotal
        } else if (extra.extra_type === 1) {
            extraTotal = (count * totalDays * extra.daily)
            finalCount = count * totalDays
            extraAmount = (count * totalDays * extra.daily)
        } else if (extra.extra_type === 2) {
            extraTotal = ((this.state.end[index] - this.state.start[index]) * extra.rate)
            finalCount = (this.state.end[index] - this.state.start[index])
            extraAmount = ((this.state.end[index] - this.state.start[index]) * extra.rate)
        } else if (extra.extra_type === 3) {
            extraTotal = (count * extra.charge)
            finalCount = count
            extraAmount = (count * extra.charge)
        } else {
            extraTotal = extra.charge
            finalCount = ''
            extraAmount = extra.charge
        }
        this.calculateTaxAndTotal(this.state.subTotal + extraTotal, duration, this.state.extraSubTotal + extraTotal);
        this.setState({
            subTotal: this.state.subTotal + extraTotal,
            subTotalWithoutDiscount: this.state.subTotalWithoutDiscount + extraTotal,
            selectedExtras: [...this.state.selectedExtras, extra.name],
            selectedExtraCount: [...this.state.selectedExtraCount, finalCount],
            selectedExtraAmount: [...this.state.selectedExtraAmount, extraAmount],
            extraSubTotal: this.state.extraSubTotal + extraAmount,
            extraId: [...this.state.extraId, extra.id]
        })
    }

    handleCountChange = (index, event) => {
        const newCounts = { ...this.state.counts, [index]: event.target.value };
        this.setState({ counts: newCounts });
    };

    handlePaymentSelect = (value) => {
        let convenienceFees = 0.0
        let partialTotal = 0.0
        let balance = 0.0
        let totalAmount = 0.0
        if (value === 'checkoutPayment') {
            this.setState({
                // totalAmount: this.state.totalAmount - this.state.convenienceCharge,
                totalAmount: this.state.totalAmount,
                convenienceCharge: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? 0.0 : null,
                selectedPaymentValue: value
            },
            () => {
                this.userDetailsValidation();
            })
        } else if (value === 'partialPayment') {
            convenienceFees = (this.state.baseTotal * this.state.convenienceFees / 100);
            partialTotal = parseFloat(this.state.baseTotal) + parseFloat(convenienceFees.toFixed(2))
            balance = 0.0
            this.setState({
                partialBase: this.state.baseTotal,
                convenienceCharge: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? convenienceFees.toFixed(2) : null,
                partialTotal: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? partialTotal.toFixed(2) : parseFloat(this.state.baseTotal),
                // balance: balance.toFixed(2),
                selectedPaymentValue: value
            },
            () => {
                this.userDetailsValidation();
            })
        } else if (value === 'fullPayment') {
            convenienceFees = (this.state.baseTotal * this.state.convenienceFees / 100);
            totalAmount = parseFloat(this.state.baseTotal)
            this.setState({
                convenienceCharge: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? convenienceFees.toFixed(2) : null,
                totalAmount: parseFloat(this.state.baseTotal),
                selectedPaymentValue: value
            },
            () => {
                this.userDetailsValidation();
            })
        } else if (value === 'cash' || value === 'check') {
            this.setState({
                totalAmount: parseFloat(this.state.baseTotal),
                convenienceCharge: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? 0.0 : null,
                selectedPaymentValue: value
            },
            () => {
                this.userDetailsValidation();
            })
        } else if (value === 'ccPOS') {
            convenienceFees = (this.state.baseTotal * this.state.convenienceFees / 100);
            totalAmount = parseFloat(this.state.baseTotal) + parseFloat(convenienceFees.toFixed(2))
            this.setState({
                convenienceCharge: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? 0.0 : null,
                totalAmount: parseFloat(this.state.baseTotal),
                ccPOSAmount: (parseFloat(this.state.baseTotal)),
                selectedPaymentValue: value
            },
            () => {
                this.userDetailsValidation();
            })
        } else if (value === 'others') {
            this.setState({
                totalAmount: parseFloat(this.state.baseTotal),
                convenienceCharge: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? 0.0 : null,
                selectedPaymentValue: value
            },
            () => {
                this.userDetailsValidation();
            })
        }
    }

    amountChange = (event) => {
        if (this.state.selectedPaymentValue === 'check' || this.state.selectedPaymentValue === 'cash' || this.state.selectedPaymentValue === 'ccPOS' || this.state.selectedPaymentValue === 'others') {
            if(event.target.id === 'offlineLast4')
                {
                    if (/^\d{0,4}$/.test(event.target.value)) {
                        this.setState({ offlineLast4: event.target.value },() => {
                            this.userDetailsValidation();
                        });
                      }
                }
                else{
                    this.setState({
                        [event.target.id]: event.target.value
                    },() => {
                        this.userDetailsValidation();
                    })
                }
        } else {
            let convenience = 0.0
            let totalPartialAmount = 0.0
            convenience = (event.target.value * this.state.convenienceFees / 100)
            totalPartialAmount = parseFloat(event.target.value) + parseFloat(convenience.toFixed(2))
            this.setState({
                partialTotal: totalPartialAmount.toFixed(2),
                convenienceCharge: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? convenience.toFixed(2) : null,
                partialBase: event.target.value
            })
        }
    }

    handlePaymentDetailsChange = (event) => {
        this.setState({
            [event.target.id]: event.target.value
        }, () => {
            this.userDetailsValidation();
        })
    }

    userDetailsValidation = () => {
        if(this.state.selectedPaymentValue === 'fullPayment' || this.state.selectedPaymentValue === 'partialPayment'){

            if (this.state.fname && this.state.lname && this.state.emailId && this.state.phoneNumber && this.state.address && this.state.city && this.state.state && this.state.zip && this.state.cardNumber && this.state.cardOwner && this.state.expiryMonth && this.state.expiryMonth && this.state.expiryYear && this.state.cvv
            ) {
                this.setState({
                    userDetailsFormValid: true
                })
            } else if (this.state.userDetailsFormValid) {
                this.setState({
                    userDetailsFormValid: false
                })
            }

        } else if(this.state.selectedPaymentValue === 'ccPOS'){
            if (this.state.fname && this.state.lname && this.state.emailId && this.state.phoneNumber && this.state.address && this.state.city && this.state.state && this.state.zip
            ) {
                this.setState({
                    userDetailsFormValid: true
                })
            } else if (this.state.userDetailsFormValid) {
                this.setState({
                    userDetailsFormValid: false
                })
            }
        } else if (this.state.selectedPaymentValue === 'others') {
            if (this.state.fname && this.state.lname && this.state.emailId && this.state.phoneNumber && this.state.offlineMethod && this.state.offlineAmount && this.state.offlinePaymentDate) {
                this.setState({
                    userDetailsFormValid: true
                })
            } else {
                this.setState({
                    userDetailsFormValid: false
                })
            }
        } else {
            if (this.state.fname && this.state.lname && this.state.emailId && this.state.phoneNumber) {
                this.setState({
                    userDetailsFormValid: true
                })
            } else if (this.state.userDetailsFormValid) {
                this.setState({
                    userDetailsFormValid: false
                })
            }
        }
    }

    handleStripeSuccess = async (paymentIntent) => {
        this.setState({
            userDetailsFormValid: false,
            open2: true,
        })
        let amount;
        if (this.state.selectedPaymentValue === 'fullPayment') {
            amount = this.state.totalAmount
        } else {
            amount = this.state.partialTotal
        }
        if (paymentIntent.status === "succeeded") {
            const cardDetails = await getPaymentMethod(paymentIntent.payment_method);
            this.setState({
                amountPaid: amount
            })
            let reservation = await this.makeReservation(amount)
            let cardId = await getCardType(cardDetails.brand)
            let paymentRecords = await recordPayment(this.props.user, this.props.serverName, amount, reservation.insertId, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
            paymentIntent.id, cardId, cardDetails.last4, `${this.state.fname} ${this.state.lname}`, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), 1, paymentIntent.payment_method)
            let aaddExtra = this.addExtraToDatabase(reservation.insertId)
            let addVariableCharge = this.addVariableChargesToDatabase(reservation.insertId)
            this.sendReservationConfirmationMail(reservation.insertId)
        } else {
            this.setState({
                open2: false,
                open: true,
                popupText: 'Payment declined. Please try again.'
            })
        }
    };
    handleStripeFail = async (message) => {
        this.setState({
            open2: false,
            open: true,
            popupText: `Payment declined. ${message}.`
        })
    };

    pay = async () => {
        this.setState({
            userDetailsFormValid: false,
            open2: true,
        })
        let amount;
        if (this.state.selectedPaymentValue === 'fullPayment' || this.state.selectedPaymentValue === 'partialPayment') {
            amount = this.state.totalAmount
            if (this.state.selectedPaymentValue === 'fullPayment') {
                amount = this.state.totalAmount
            } else {
                amount = this.state.partialTotal
            }

            if (this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o') {
                if (this.state.selectedPaymentValue === 'fullPayment') {
                    amount = parseFloat(amount) + parseFloat(this.state.convenienceCharge)
                    console.log("amount: ", amount)
                } else {
                    console.log("amount: ", amount)
                }
                let payment
                if (this.state.payWithSavedCard) {
                    payment = await makeVaultedPayment(this.state.paymentIntegration.cp_merchantid, amount, this.state.paymentToken)
                    // payment = await makeVaultedPayment('1000017768', amount, this.state.paymentToken)
                    console.log("Payment Response: ", payment)
                } else {
                    payment = await makePayment(this.state.paymentIntegration.cp_merchantid, amount, this.state.cardNumber, this.state.expiryMonth, this.state.expiryYear, this.state.cvv, this.state.zip, this.state.address)
                    // payment = await makePayment('1000017768', amount, this.state.cardNumber, this.state.expiryMonth, this.state.expiryYear, this.state.cvv, this.state.zip, this.state.address)
                    console.log("Payment Response: ", payment)
                }

                if (payment.status === 'Approved') {
                    this.setState({
                        amountPaid: amount
                    })
                    let rigId = 0;
                    let taxtotal = 0.0;
                    //rig
                    for (let index = 0; index < this.props.rigs.length; index++) {
                        if (this.props.rigType === this.props.rigs[index].name) {
                            rigId = this.props.rigs[index].id
                        }
                    }
                    //tax
                    for (let index = 0; index < this.state.tax.length; index++) {
                        if (this.state.tax[index] !== undefined) {
                            taxtotal = taxtotal + this.state.tax[index];
                        }
                    }
                    console.log(((parseFloat(this.state.totalAmount) + parseFloat(this.state.convenienceCharge)) - parseFloat(taxtotal)))
                    let reservation = await makeReservation(this.props.user, this.props.serverName, this.state.lname, this.state.fname, this.state.address, this.state.city, this.state.state,
                        this.state.zip, this.state.phoneNumber, this.state.emailId, rigId, this.props.siteId, this.props.discountId, this.props.checkIn, this.props.checkOut, amount,
                        this.props.slides, this.props.rigLength, this.props.guests, this.props.pets, ((parseFloat(this.state.totalAmount) + parseFloat(this.state.convenienceCharge)) - parseFloat(taxtotal)),
                        format(new Date(), 'yyyy-MM-dd HH:mm:ss'), taxtotal, 0, this.state.internalNotes, this.state.oneTimeDiscount, this.state.camperId, this.props.seasonBooking ? 1 : 0, this.state.daySpecificRatesStatus ? 1 : 0
                    );
                    console.log("reservation.insertId: ", reservation.insertId)
                    if (this.state.paymentIntegration.name.includes('CampPay') && !this.state.paymentIntegration.cp_merchantid) {
                        let response2 = await addSystemFeeRecord(this.props.serverName, reservation.insertId, this.props.checkIn, this.props.checkOut, 'manager', 'created')
                    }

                    if (this.state.saveCard) {
                        console.log("saving camper cards")
                        let saveCardResponse = await insertCamperCard(this.props.user, this.props.serverName, reservation.camperId, payment.cardAccount.token, payment.cardAccount.last4)
                    }

                    let cardId = await getCardType(payment.cardAccount.cardType)
                    let paymentRecords = await recordPayment(this.props.user, this.props.serverName, amount, reservation.insertId, payment.created, payment.created,
                        payment.reference, cardId, payment.cardAccount.last4, this.state.cardOwner, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), 1, payment.cardAccount.token
                    )

                    let variableChargeResponse = await addVariableCharge(this.props.user, this.props.serverName, reservation.insertId, "Service Fees", this.state.convenienceCharge, new Date(), new Date(), 0)
                    let aaddExtra = this.addExtraToDatabase(reservation.insertId)
                    let addVariableCharges = this.addVariableChargesToDatabase(reservation.insertId)
                    this.sendReservationConfirmationMail(reservation.insertId)
                } else {
                    this.setState({
                        open2: false,
                        open: true,
                        popupText: 'Payment declined. Please try again.'
                    })
                }
            } else if (this.state.paymentIntegration.name === 'CardConnect' || this.state.paymentIntegration.name === 'CardConnect_o') {
                amount = parseFloat(amount).toFixed(2);
                let paymentResponse = await cardConnectPaymemt(this.props.user, this.state.paymentIntegration.cc_merchant_id, amount, this.state.cardNumber, this.state.expiryMonth, this.state.expiryYear,
                    this.state.cvv, this.state.zip, this.state.address, this.state.fname, this.state.city, this.state.paymentIntegration.cc_api_username, this.state.paymentIntegration.cc_api_password)
                console.log("payment: ", paymentResponse)
                if (paymentResponse.respstat === "A") {
                    this.setState({
                        amountPaid: amount
                    })
                    let reservation = await this.makeReservation(amount)
                    if (this.state.paymentIntegration.name.includes('CardConnect') && !this.state.paymentIntegration.cc_merchant_id) {
                        let response2 = await addSystemFeeRecord(this.props.serverName, reservation.insertId, this.props.checkIn, this.props.checkOut, 'manager', 'created')
                    }
                    let cardId = await getCardType(paymentResponse.binInfo.product)
                    let paymentRecords = await recordPayment(this.props.user, this.props.serverName, amount, reservation.insertId, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                        paymentResponse.retref, cardId, paymentResponse.account.slice(-4), this.state.cardOwner, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), 1, paymentResponse.token)
                    let aaddExtra = this.addExtraToDatabase(reservation.insertId)
                    let addVariableCharge = this.addVariableChargesToDatabase(reservation.insertId)
                    this.sendReservationConfirmationMail(reservation.insertId)
                } else {
                    this.setState({
                        open2: false,
                        open: true,
                        popupText: 'Payment declined. Please try again.'
                    })
                }
            }
        } else if (this.state.selectedPaymentValue === 'ccPOS') {
            let popupText=''
            this.setState({
                open2: false,
                open1: true,
                popupText1: 'We’re now communicating with the card terminal. Please follow the instructions on the terminal to complete your payment. Do not close this window or navigate away until the payment is complete.'
            })
            if (this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o') {
                //call jwt api
                let getJWTTokenResponse = await getJWTToken(this.state.paymentIntegration.cp_merchantid)
                console.log("JWT Token: ", getJWTTokenResponse.jwtToken)

                //call get list of terminal api with received jwt token
                let getListOfTerminalsResponse = await getListOfTerminals(this.state.paymentIntegration.cp_merchantid, getJWTTokenResponse.jwtToken)
                console.log('Terminal ID: ', getListOfTerminalsResponse[0].id)

                //call getReplayID api
                let replayID = await getReplayID(this.props.user, this.props.serverName)
                console.log("ReplayId: ", replayID[0].replayID)

                //call updateReplayID api
                let updateReplayIDResponse = await updateReplayID(this.props.user, this.props.serverName)
                console.log("Update ReplayId response: ", updateReplayIDResponse)

                //call create terminal payment api
                let createTerminalPaymentResponse = await createTerminalPayment(this.state.paymentIntegration.cp_merchantid, getJWTTokenResponse.jwtToken, this.state.ccPOSAmount, getListOfTerminalsResponse[0].id, replayID[0].replayID)
                console.log("createTerminalPaymentResponse: ", createTerminalPaymentResponse)

                //terminal transaction get to get the reference number
                let getTerminalTransactionResponse = await getTerminalTransaction(this.state.paymentIntegration.cp_merchantid, replayID[0].replayID)
                // let getTerminalTransactionResponse = await getTerminalTransaction(this.state.paymentIntegration.cp_merchantid, 54)
                console.log("getTerminalTransactionResponse: ", getTerminalTransactionResponse)

                //record payment
                if (getTerminalTransactionResponse === null) {
                    popupText = 'No Response from POS Terminal.'
                } else {
                    if (getTerminalTransactionResponse.status === 'Approved') {
                        let cardId = await getCardType(getTerminalTransactionResponse.cardAccount.cardType)
                        console.log("CardId: ", cardId)
                        await recordPayment(this.props.user, this.props.serverName, getTerminalTransactionResponse.amount, this.props.viewItem.id,
                            format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'), "POS Terminal: " + getTerminalTransactionResponse.reference,
                            cardId, getTerminalTransactionResponse.cardAccount.last4, "", format(new Date(), 'yyyy-MM-dd HH:mm:ss'), 1)
                        await addVariableCharge(this.props.user, this.props.serverName, this.props.viewItem.id, "Service Fees", this.state.convenienceCharge, new Date(), new Date())
                        popupText = 'POS terminal payment added successfully.'
                    } else {
                        popupText = 'POS terminal payment declined. Please try again.'
                    }
                }

                this.setState({
                    open1: false,
                    open: true,
                    popupText: popupText
                })
            } else {
                let listOfTerminals = await cardConnectGetListOfTerminals(this.props.user, this.state.paymentIntegration.cc_merchant_id)
                let connectToTerminalResponse = await cardConnectConnectToTerminal(this.props.user, this.state.paymentIntegration.cc_merchant_id, listOfTerminals.terminals[0])
                let popupText
                if (connectToTerminalResponse.status === 200) {
                    let paymentResponse = await cardConnectTerminalPayment(this.props.user, this.state.paymentIntegration.cc_merchant_id, listOfTerminals.terminals[0], this.state.ccPOSAmount * 100, connectToTerminalResponse.SessionKey)
                    if (paymentResponse.errorCode === 8) {
                        popupText = 'Payment Cancelled By User'
                    } else if (paymentResponse.resptext === 'Approval') {
                        this.setState({
                            amountPaid: amount
                        })
                        let reservation = await this.makeReservation(this.state.ccPOSAmount)
                        if (this.state.paymentIntegration.name == 'None' || (this.state.paymentIntegration.name.includes('CardConnect') && !this.state.paymentIntegration.cc_merchant_id) || (this.state.paymentIntegration.name.includes('CampPay') && !this.state.paymentIntegration.cp_merchantid)) {
                            let response2 = await addSystemFeeRecord(this.props.serverName, reservation.insertId, this.props.checkIn, this.props.checkOut, 'manager', 'created')
                        }
                        //hard coded 2 for cardId after reference number
                        await recordPayment(this.props.user, this.props.serverName, this.state.ccPOSAmount, reservation.insertId, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                            "POS Terminal: " + paymentResponse.retref, "2", "", "", format(new Date(), 'yyyy-MM-dd HH:mm:ss'), 1)
                        let aaddExtra = this.addExtraToDatabase(reservation.insertId)
                        let addVariableCharge = this.addVariableChargesToDatabase(reservation.insertId)
                        this.sendReservationConfirmationMail(reservation.insertId)
                    } else {
                        popupText = 'POS Terminal Payment Declined. Please try again'
                    }
                } else {
                    popupText = 'The system cannot connect to your POS terminal. This can be due to the POS terminal being offline, or because you do not have a merchant account configured with one of our card processors. Please use an alternate payment method.'
                }
                this.setState({
                    open1: false,
                    open: true,
                    popupText: popupText
                })
            }
        } else if (this.state.selectedPaymentValue === 'cash') {
            this.setState({
                amountPaid: amount
            })
            let reservation = await this.makeReservation(this.state.cashAmount)
            let paymentRecords = await recordPayment(this.props.user, this.props.serverName, this.state.cashAmount, reservation.insertId, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                "Cash Payment", "1", "", this.state.fname + " " + this.state.lname, this.state.cashDate.format('YYYY-MM-DD'), 1)
            let response = await addSystemFeeRecord(this.props.serverName, reservation.insertId, this.props.checkIn, this.props.checkOut, 'manager', 'cash')
            let aaddExtra = this.addExtraToDatabase(reservation.insertId)
            let addVariableCharge = this.addVariableChargesToDatabase(reservation.insertId)
            this.sendReservationConfirmationMail(reservation.insertId)
        } else if (this.state.selectedPaymentValue === 'check') {
            this.setState({
                amountPaid: amount
            })
            let reservation = await this.makeReservation(this.state.checkAmount)
            let paymentRecords = await recordPayment(this.props.user, this.props.serverName, this.state.checkAmount, reservation.insertId, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                "Check Payment" + this.state.memo, "2", "", this.state.fname + " " + this.state.lname, this.state.checkDate.format('YYYY-MM-DD'), 1)
            let response = await addSystemFeeRecord(this.props.serverName, reservation.insertId, this.props.checkIn, this.props.checkOut, 'manager', 'check')
            let aaddExtra = this.addExtraToDatabase(reservation.insertId)
            let addVariableCharge = this.addVariableChargesToDatabase(reservation.insertId)
            this.sendReservationConfirmationMail(reservation.insertId)
        } else if (this.state.selectedPaymentValue === 'others') {
            this.setState({
                amountPaid: amount
            })
            let reservation = await this.makeReservation(this.state.offlineAmount)
            let paymentRecords = await recordPayment(this.props.user, this.props.serverName, this.state.offlineAmount, reservation.insertId, format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                format(new Date(), 'yyyy-MM-dd HH:mm:ss'), `${this.state.offlineMethod}: ${this.state.offlineMemo||''}`, "7", this.state.offlineLast4, this.state.fname + " " + this.state.lname, this.state.offlinePaymentDate.format('YYYY-MM-DD'), 1)
            let response = await addSystemFeeRecord(this.props.serverName, reservation.insertId, this.props.checkIn, this.props.checkOut, 'manager', 'offlinePayment')
            let aaddExtra = this.addExtraToDatabase(reservation.insertId)
            let addVariableCharge = this.addVariableChargesToDatabase(reservation.insertId)
            this.sendReservationConfirmationMail(reservation.insertId)
        } else {
            this.setState({
                amountPaid: '0.00'
            })
            let reservation = await this.makeReservation("")
            if (this.state.paymentIntegration.name == 'None' || (this.state.paymentIntegration.name.includes('CardConnect') && !this.state.paymentIntegration.cc_merchant_id) || (this.state.paymentIntegration.name.includes('CampPay') && !this.state.paymentIntegration.cp_merchantid)) {
                let response2 = await addSystemFeeRecord(this.props.serverName, reservation.insertId, this.props.checkIn, this.props.checkOut, 'manager', 'created')
            }
            console.log("reservation: ", reservation)
            let aaddExtra = this.addExtraToDatabase(reservation.insertId)
            let addVariableCharge = this.addVariableChargesToDatabase(reservation.insertId)
            this.sendReservationConfirmationMail(reservation.insertId)
        }
    }

    makeReservation = async (amountPaid) => {
        let rigId;
        let taxtotal = 0.0;
        //rig
        for (let index = 0; index < this.props.rigs.length; index++) {
            if (this.props.rigType === this.props.rigs[index].name) {
                rigId = this.props.rigs[index].id
            }
        }
        //tax
        for (let index = 0; index < this.state.tax.length; index++) {
            if (this.state.tax[index] !== undefined) {
                taxtotal = taxtotal + parseFloat(this.state.tax[index]);
            }
        }
        let reservation = await makeReservation(this.props.user, this.props.serverName, this.state.lname, this.state.fname, this.state.address, this.state.city, this.state.state,
            this.state.zip, this.state.phoneNumber, this.state.emailId, rigId, this.props.siteId, this.props.discountId, this.props.checkIn, this.props.checkOut, amountPaid, //payment.amount
            this.props.slides, this.props.rigLength, this.props.guests, this.props.pets, (parseFloat(this.state.totalAmount) - taxtotal), format(new Date(), 'yyyy-MM-dd HH:mm:ss'), taxtotal, 0, this.state.internalNotes,
            this.state.oneTimeDiscount, this.state.camperId, this.props.seasonBooking ? 1 : 0, this.state.daySpecificRatesStatus ? 1 : 0
        );
        console.log("reservation: ", reservation)
        return reservation
    }

    addExtraToDatabase = async (reservationId) => {
        if (this.state.selectedExtras.length > 0) {
            let days = this.getDays()
            for (let index = 0; index < this.state.selectedExtras.length; index++) {
                let extraResponse = await addExtras(this.props.user, this.props.serverName, this.state.extraId[index], reservationId, this.state.selectedExtraCount[index], days, this.state.selectedExtraAmount[index], format(new Date(), 'yyyy-MM-dd HH:mm:ss'))
            }
        }
        return
    }

    addVariableChargesToDatabase = async (reservationId) => {
        if (this.state.variableCharges.length > 0) {
            let days = this.getDays()
            for (let index = 0; index < this.state.variableCharges.length; index++) {
                let variableChargeResponse = await addVariableCharge(this.props.user, this.props.serverName, reservationId, this.state.variableCharges[index].detail, this.state.variableCharges[index].amount, new Date(), new Date(), this.state.variableCharges[index].taxable)
                // let extraResponse = await addExtras(this.props.user, this.props.serverName, this.state.extraId[index], reservationId, this.state.selectedExtraCount[index], days, this.state.selectedExtraAmount[index], format(new Date(), 'yyyy-MM-dd HH:mm:ss'))
            }
        }
        return
    }

    sendReservationConfirmationMail = async (reservationId) => {
        let mailmessage = this.replaceMailTemplatePlaceHolders(reservationId)
        let mailResponse = await sendMail(this.props.user, this.props.serverName, this.state.sender, this.state.emailId, this.state.remoteReservationReceivedSubject, mailmessage, this.state.reply, this.state.cc, this.state.bcc, this.state.remoteResReceivedAttachments)
        this.setState({
            open2: false,
            open: true,
            popupText: 'Reservation created with reservation number: ' + reservationId
        })
    }

    replaceMailTemplatePlaceHolders = (reservationId) => {
        let mailMessage = this.state.remoteResReceivedMailMessage
        mailMessage = mailMessage.replace('{{camper}}', this.state.fname + ' ' + this.state.lname);
        mailMessage = mailMessage.replace('{{space_name}}', this.props.spaceName);
        mailMessage = mailMessage.replace('{{number}}', reservationId);
        mailMessage = mailMessage.replace('{{created}}', format(new Date(), 'yyyy-MM-dd HH:mm:ss'));
        mailMessage = mailMessage.replace('{{start}}', this.props.checkIn);
        mailMessage = mailMessage.replace('{{departure}}', this.props.checkOut);
        mailMessage = mailMessage.replace('{{charges}}', this.state.totalAmount);
        mailMessage = mailMessage.replace('{{payment}}', this.state.amountPaid);
        mailMessage = mailMessage.replace('{{due}}', this.state.totalAmount - this.state.amountPaid);
        mailMessage = mailMessage.replace('{{deposit}}', this.state.amountPaid);
        return mailMessage
    }

    handleStartEnd = (event, index) => {
        this.setState((prevState) => {
            const updatedArray = [...prevState[event.target.id]];
            updatedArray[index] = event.target.value;

            return {
                [event.target.id]: updatedArray
            };
        }, () => {
            this.validateAddOns(index);
        });
    }

    validateAddOns = (index) => {
        if (this.state.start[index] > 0 && this.state.end[index] > 0 && this.state.end[index] > this.state.start[index]) {
            this.setState({
                type2Add: true
            })
        } else if (this.state.type2Add) {
            this.setState({
                type2Add: false
            })
        }
    }

    deleteExtra = async (index) => {
        console.log("extra id: ", this.state.extraId[index])
        let term = this.getDuration(this.props.checkIn, this.props.checkOut)
        this.calculateTaxAndTotal(this.state.subTotal - this.state.selectedExtraAmount[index], term, this.state.extraSubTotal - this.state.selectedExtraAmount[index]);
        let array1 = [...this.state.selectedExtras];
        let array2 = [...this.state.selectedExtraCount];
        let array3 = [...this.state.selectedExtraAmount];
        array1.splice(index, 1);
        array2.splice(index, 1);
        array3.splice(index, 1);
        this.setState({
            selectedExtras: array1,
            selectedExtraCount: array2,
            selectedExtraAmount: array3,
            subTotal: this.state.subTotal - this.state.selectedExtraAmount[index],
            subTotalWithoutDiscount: this.state.subTotalWithoutDiscount - this.state.selectedExtraAmount[index],
            extraSubTotal: this.state.extraSubTotal - this.state.selectedExtraAmount[index]
        });
    }

    deleteVariableCharge = async (index) => {
        console.log("extra id: ", this.state.variableCharges[index])
        let array1 = [...this.state.variableCharges];
        array1.splice(index, 1);
        this.setState({
            variableCharges: array1,
            subTotal: this.state.subTotal
        });
        this.calculateTaxAndTotal(this.state.subTotal, this.getDuration(this.props.checkIn, this.props.checkOut), this.state.extraSubTotal);
    }

    handleCancel = () => {
        this.setState({ open: false }, () => {
            this.props.history.replace(`/manager?serverName=${this.props.serverName}&view=reservations`);
        });
    };

    addOneTimeDiscount = (event) => {
        if (event.target.value == "") {
            let newSubtotal = parseFloat(this.state.subTotalWithoutDiscount)
            this.calculateTaxAndTotal(newSubtotal, this.getDuration(this.props.checkIn, this.props.checkOut), this.state.extraSubTotal);
            this.setState({
                oneTimeDiscount: 0,
                subTotal: newSubtotal
            })
        } else if (event.target.value >= 0) {
            // const numericValue = event.target.value.replace(/[^0-9]/g, '');
            const numericValue = event.target.value
            let oneTimeDiscount = parseFloat(numericValue)
            // let newSubtotal = this.state.originalSubTotal - oneTimeDiscount
            let newSubtotal = this.state.subTotalWithoutDiscount - oneTimeDiscount
            console.log(this.state.subTotalWithoutDiscount, oneTimeDiscount, newSubtotal, this.state.extraSubTotal);
            this.calculateTaxAndTotal(newSubtotal, this.getDuration(this.props.checkIn, this.props.checkOut), this.state.extraSubTotal);
            this.setState({
                oneTimeDiscount: oneTimeDiscount,
                subTotal: newSubtotal
            });
        }
    }

    newVariableChargeChange = (event) => {
        if (event.target.id === 'newVariableChargeAmount') {
            const amount = event.target.value
            // const alteredAmount = amount.replace(/[^0-9]/g, '');
            const alteredAmount = amount;
            this.setState({
                [event.target.id]: alteredAmount
            })
        } else {
            this.setState({
                [event.target.id]: event.target.type === "checkbox" ? event.target.checked : event.target.value
            })
        }
    }

    addNewVariableCharge = async () => {
        this.setState({
            reservationUpdated: true
        })
        // let variableChargeResponse = await addVariableCharge(this.props.user, this.props.serverName, this.props.viewItem.id, this.state.newVariableChargeName, this.state.newVariableChargeAmount, new Date(), new Date(), this.state.taxable)
        const newCharge = {
            // id: variableChargeResponse.insertId,
            // reservation_id: this.props.viewItem.id,
            detail: this.state.newVariableChargeName,
            amount: Number(this.state.newVariableChargeAmount).toFixed(2),
            taxable: this.state.taxable ? 1 : 0,
            // created_at: new Date().toISOString(),
            // updated_at: new Date().toISOString(),
        };
        console.log(newCharge)
        this.setState({ variableCharges: [...this.state.variableCharges, newCharge] });
        let chargeAmount = this.state.taxable ? parseFloat(this.state.newVariableChargeAmount).toFixed(2) : 0
        console.log(chargeAmount)
        console.log(this.state.subTotal, chargeAmount);
        this.calculateTaxAndTotal(this.state.subTotal, this.getDuration(this.props.checkIn, this.props.checkOut), this.state.extraSubTotal);
    }

    render() {
        const { classes } = this.props;
        return (
            <Grid className='reservationList' style={{ width: '100%' }}>
                <ThemeProvider theme={theme} classes={{ paper: classes.dialogPaper }}>
                    <Dialog open={this.state.open} onClose={this.handleCancel}>
                        <DialogTitle>Reservation Summary</DialogTitle>
                        <DialogContent>
                            {this.state.popupText}
                        </DialogContent>
                        <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Button onClick={this.handleCancel} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={this.state.open2} onClose={() => this.setState({ open2: false })} classes={{ paper: classes.dialogPaper }}>
                        <DialogContent>
                            Creating your reservation. Please wait.
                        </DialogContent>
                    </Dialog>

                    <Dialog open={this.state.saveCardOnFileDialogue} onClose={() => this.setState({ saveCardOnFileDialogue: false })}>
                        <DialogTitle>Card Storage Compliance Notice</DialogTitle>
                        <DialogContent>
                            <Typography style={{ marginBottom: '2%' }}>By enabling the "Save Card on File" feature, you confirm that:</Typography>
                            <Typography style={{ marginBottom: '2%', marginLeft: '5%' }}> • You will obtain and document guest consent before storing their card information.</Typography>
                            <Typography style={{ marginBottom: '2%' }}><strong>Legal Requirement:</strong> : Storing payment cards without explicit customer consent violates payment card regulations and may result in financial penalties, chargebacks, and loss of payment processing privileges.</Typography>

                            <FormControlLabel
                                label={`I understand these requirements and will ensure proper consent is obtained before storing any payment card information.`}
                                control={
                                    <GreenCheckbox
                                        id="complianceAgreed"
                                        checked={this.state.complianceAgreed}
                                        onChange={(e) => this.setState({ complianceAgreed: e.target.checked, saveCardOnFileDialogue: false })}
                                    />
                                }
                            />
                        </DialogContent>
                        <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Button onClick={() => this.setState({ saveCardOnFileDialogue: false, saveCard: false })} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                </ThemeProvider>

                {this.state.waitForCalculations
                    ?
                    <CircularProgress className={classes.circularProgress} />
                    :
                    <>
                        {this.state.userDetails
                            ?
                            <>
                                <Box className='scrollContainerUserDetails'>
                                    <Box className='box' style={{ width: '90%', marginLeft: '2%' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', marginLeft: '-3.3%' }}>
                                            <img src={reservationConfirmation} alt="Reservations" style={{ height: '40px' }} />
                                            <Typography className='reservationstypography'>Confirm Reservation</Typography>
                                        </div>
                                        <div style={{ marginRight: '-3%' }}>
                                            <Button startIcon={<ArrowBackIcon />} className='cancel' style={{ marginRight: '2%', backgroundColor: "rgb(153, 153, 153)", color: "#FFF" }} onClick={() => {
                                                this.props.backToSelectSpace();
                                            }}>Select Space</Button>
                                            <Button className='cancel' style={{ marginRight: '-2%' }} onClick={() => {
                                                this.props.history.replace(`/manager?serverName=${this.props.serverName}&view=reservations`)
                                            }}>Cancel Reservation</Button>
                                        </div>
                                    </Box>
                                    <Box className='main'>
                                        <Box className='leftRow'>
                                            <Box className='userDetails'>
                                                <ThemeProvider theme={theme}>
                                                    <Box style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
                                                        <Typography className='typo'>Guest Details</Typography>
                                                        <Box style={{ marginRight: "1%", padding: "4% 3% 0 0" }}>
                                                            <Autocomplete
                                                                disablePortal
                                                                loading={this.state?.guests?.length == 0}
                                                                filterOptions={createFilterOptions({
                                                                    ignoreCase: true,
                                                                    matchFrom: "start",
                                                                })}
                                                                onChange={(_, value) => {
                                                                    if (value) {
                                                                        this.setState({
                                                                            fname: value?.first_name,
                                                                            lname: value?.last_name,
                                                                            emailId: value?.email,
                                                                            phoneNumber: value?.phone,
                                                                            address: value?.address,
                                                                            city: value?.city,
                                                                            state: value?.state,
                                                                            zip: value?.mail_code,
                                                                            camperId: value?.id,
                                                                            paymentToken: value?.token,
                                                                            last4: value?.last4
                                                                        }, () => {
                                                                            this.userDetailsValidation();
                                                                        })
                                                                    }

                                                                }}
                                                                options={this.state?.guests && this.state?.guests?.length > 0 ? this.state?.guests.map((i) => ({ ...i, label: i.first_name + " " + i.last_name, key: i.id })) : []}
                                                                sx={{ width: 300 }}
                                                                renderInput={(params) => <TextField {...params} label="Search Guest" />}
                                                            />
                                                        </Box>
                                                    </Box>
                                                    <hr className='horizontalLine' />
                                                    <div className='form-row' style={{ marginTop: '-5%' }}>
                                                        <Typography className='typo' style={{ fontSize: '1rem', color: 'red', marginTop: '1%' }}>(* All fields are required)</Typography>
                                                    </div>
                                                    <div className='form-row'>
                                                        <TextField id="fname" required label="First Name" type="text" className='field' value={this.state.fname} onChange={this.userDetailsChange} />
                                                        <TextField id="lname" required label="Last Name" type="text" className='field' value={this.state.lname} onChange={this.userDetailsChange} />
                                                    </div>
                                                    <div className='form-row'>
                                                        <TextField id="emailId" required label="Email Id" type="email" className='field' value={this.state.emailId} onChange={this.userDetailsChange} />
                                                        <TextField id="phoneNumber" required label="Phone Number" type="text" className='field' value={this.state.phoneNumber} onChange={this.userDetailsChange}
                                                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                                        />
                                                    </div>
                                                    <div className='form-row-2'>
                                                        <TextField id="address" required={this.state.selectedPaymentValue === 'fullPayment' || this.state.selectedPaymentValue === 'partialPayment' || this.state.selectedPaymentValue === 'ccPOS'} label="Address" type="text" className='full-width' value={this.state.address} onChange={this.userDetailsChange} />
                                                    </div>
                                                    <div className='form-row-3'>
                                                        <TextField id="city" required={this.state.selectedPaymentValue === 'fullPayment' || this.state.selectedPaymentValue === 'partialPayment' || this.state.selectedPaymentValue === 'ccPOS'} label="City" type="text" className='left' value={this.state.city} onChange={this.userDetailsChange} />
                                                        <TextField id="state" required={this.state.selectedPaymentValue === 'fullPayment' || this.state.selectedPaymentValue === 'partialPayment' || this.state.selectedPaymentValue === 'ccPOS'} label="State" type="text" className='middle' value={this.state.state} onChange={this.userDetailsChange} />
                                                        <TextField id="zip" required={this.state.selectedPaymentValue === 'fullPayment' || this.state.selectedPaymentValue === 'partialPayment' || this.state.selectedPaymentValue === 'ccPOS'} label="Postal Code" type="text" className='right' value={this.state.zip} onChange={this.userDetailsChange} />
                                                    </div>
                                                </ThemeProvider>
                                            </Box>

                                            {this.state.useVariable
                                                ?
                                                <Box className='variableCharge'>
                                                    <Typography className='typo'>Variable Charges</Typography>
                                                    <hr className='horizontalLine' />
                                                    <ThemeProvider theme={theme}>
                                                        <Box style={{ display: 'flex', justifyContent: 'space-between', margin: '0 3% 2% 3%' }}>
                                                            <TextField style={{ width: '30%', marginRight: '-20%' }} onChange={this.newVariableChargeChange}
                                                                id="newVariableChargeName" type="text" label="Item"
                                                                value={this.state.newVariableChargeName}
                                                            />
                                                            <TextField style={{ width: '20%', marginRight: '-20%' }} onChange={this.newVariableChargeChange}
                                                                id="newVariableChargeAmount" type="number" label="Amount"
                                                                // inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                                                inputProps={{ step: "any", min: "0" }}
                                                                value={this.state.newVariableChargeAmount}
                                                            />
                                                            <FormControlLabel
                                                                label={"Taxable?"}
                                                                style={{ width: '20%', marginRight: '-22%' }}
                                                                control={
                                                                    <Checkbox
                                                                        id="taxable"
                                                                        style={{ color: '#2dcd7a' }}
                                                                        checked={this.state.taxable}
                                                                        onChange={this.newVariableChargeChange}
                                                                    />
                                                                }
                                                            />
                                                            <Button onClick={() => this.addNewVariableCharge()}
                                                                style={{
                                                                    width: '20%', color: '#000000', textTransform: 'capitalize', marginRight: '1%',
                                                                    backgroundColor: !this.state.newVariableChargeName || this.state.newVariableChargeAmount <= 0 ? '#d4d4d4' : '#2dcd7a'
                                                                }}
                                                                disabled={!this.state.newVariableChargeName || this.state.newVariableChargeAmount <= 0}
                                                            >
                                                                Add
                                                            </Button>
                                                        </Box>
                                                    </ThemeProvider>
                                                </Box>
                                                : null
                                            }

                                            {this.state.selectedExtras.length > 0
                                                ?
                                                <Box className='addOns'>
                                                    <Typography className='typo'>Extras </Typography>
                                                    <hr className='horizontalLine' />
                                                    <ThemeProvider theme={theme}>
                                                        <Box className='addOnsForm'>
                                                            <Typography>Extra Name</Typography>
                                                            <Typography>Count</Typography>
                                                            <Typography>Total</Typography>
                                                        </Box>
                                                        {this.state.selectedExtras.map((extra, index) => (
                                                            <Box key={index} className='addOnsForm'>
                                                                <Typography>{this.state.selectedExtras[index]}</Typography>
                                                                <Typography>{this.state.selectedExtraCount[index]}</Typography>
                                                                <Typography>${parseFloat(this.state.selectedExtraAmount[index]).toFixed(2)}</Typography>
                                                                <Button
                                                                    style={{ backgroundColor: '#FDECEB', color: '#DB3737', borderRadius: '5px', width: '80%', marginTop: '-2%' }}
                                                                    onClick={() => this.deleteExtra(index)}
                                                                >
                                                                    Delete
                                                                </Button>
                                                            </Box>
                                                        ))}
                                                    </ThemeProvider>
                                                </Box>
                                                : null
                                            }

                                            {this.state.variableCharges.length > 0
                                                ?
                                                <Box className='addOns'>
                                                    <Typography className='typo'>Variable Charges </Typography>
                                                    <hr className='horizontalLine' />
                                                    <ThemeProvider theme={theme}>
                                                        <Box className='addOnsForm'>
                                                            <Typography>Item</Typography>
                                                            <Typography>Amount</Typography>
                                                            <Typography>Taxable</Typography>
                                                        </Box>
                                                        {this.state.variableCharges.map((extra, index) => (
                                                            <Box key={index} className='addOnsForm'>
                                                                <Typography>{this.state.variableCharges[index].detail}</Typography>
                                                                <Typography>{this.state.variableCharges[index].amount}</Typography>
                                                                <Checkbox disabled={true} checked={this.state.variableCharges[index].taxable} />
                                                                <Button
                                                                    style={{ backgroundColor: '#FDECEB', color: '#DB3737', borderRadius: '5px', width: '80%', marginTop: '-2%' }}
                                                                    onClick={() => this.deleteVariableCharge(index)}
                                                                >
                                                                    Delete
                                                                </Button>
                                                            </Box>
                                                        ))}
                                                    </ThemeProvider>
                                                </Box>
                                                : null
                                            }

                                            {this.props.extras.length > 0
                                                ?
                                                <Box className='addOns'>
                                                    <Typography className='typo'>Add-Ons</Typography>
                                                    <hr className='horizontalLine' />
                                                    <ThemeProvider theme={theme}>
                                                        {this.props.extras.map((extra, index) => (
                                                            <Box key={index} className='addOnsForm'>
                                                                {extra.extra_type === 4 || extra.extra_type === 0
                                                                    ?
                                                                    <>
                                                                        <Typography className='bookingLabel'>{extra.name}</Typography>
                                                                        <Button
                                                                            className='addButton'
                                                                            onClick={() => this.addExtra(extra)}
                                                                        >
                                                                            Add
                                                                        </Button>
                                                                    </>
                                                                    : null
                                                                }
                                                                {extra.extra_type === 2
                                                                    ?
                                                                    <>
                                                                        <Typography className='bookingLabel'>{extra.name}</Typography>
                                                                        <TextField
                                                                            required
                                                                            label="Start"
                                                                            id="start"
                                                                            type="number"
                                                                            className='textfields'
                                                                            value={this.state.start[index] || ''}
                                                                            onChange={(event) => this.handleStartEnd(event, index)}
                                                                        />
                                                                        <TextField
                                                                            required
                                                                            label="End"
                                                                            id="end"
                                                                            type="number"
                                                                            className='textfields'
                                                                            value={this.state.end[index] || ''}
                                                                            onChange={(event) => this.handleStartEnd(event, index)}
                                                                        />
                                                                        <Button
                                                                            className='addButton'
                                                                            onClick={() => this.addExtra(extra, 0, index)}
                                                                            disabled={!this.state.type2Add}
                                                                        >
                                                                            Add
                                                                        </Button>
                                                                    </>
                                                                    : null
                                                                }
                                                                {extra.extra_type === 1 || extra.extra_type === 3
                                                                    ?
                                                                    <>
                                                                        <Typography className='bookingLabel'>{extra.name}</Typography>
                                                                        <TextField
                                                                            required
                                                                            label="Count"
                                                                            type="number"
                                                                            className='textfields'
                                                                            value={this.state.counts[index] || ''}
                                                                            onChange={(event) => this.handleCountChange(index, event)}
                                                                        />
                                                                        <Button
                                                                            className='addButton'
                                                                            onClick={() => this.addExtra(extra, this.state.counts[index])}
                                                                            disabled={!(this.state.counts[index] && this.state.counts[index] > 0)}
                                                                        >
                                                                            Add
                                                                        </Button>
                                                                    </>
                                                                    : null
                                                                }
                                                            </Box>
                                                        ))}
                                                    </ThemeProvider>
                                                </Box>
                                                : null
                                            }

                                            <Box className='payment'>
                                                <Typography className='typo'>Payment Information</Typography>
                                                <hr className='horizontalLine' />
                                                <ThemeProvider theme={theme}>
                                                    <Box className='paymentOptionWrapper' style={{gap:'5px'}}>
                                                        {this.state.paymentIntegration.name === 'None' || this.state.paymentIntegration.name === 'CampPay_r' || this.state.paymentIntegration.name === 'CardConnect_r'
                                                            ?
                                                            <>
                                                                <Box className={`paymentOption ${this.state.selectedPaymentValue === "cash" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("cash") }}>
                                                                    Cash
                                                                </Box>
                                                                <Box className={`paymentOption ${this.state.selectedPaymentValue === "check" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("check") }}>
                                                                    Check / Money Order
                                                                </Box>
                                                                <Box className={`paymentOption ${this.state.selectedPaymentValue === "others" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("others") }}>
                                                                    Offline Payment method
                                                                </Box>
                                                                <Box className={`paymentOption ${this.state.selectedPaymentValue === "checkoutPayment" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("checkoutPayment") }}>
                                                                    Pay at time of checkIn
                                                                </Box>
                                                            </>
                                                            :
                                                            <>
                                                                <Box className={`paymentOption ${this.state.selectedPaymentValue === "fullPayment" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("fullPayment") }}>
                                                                    Card (Full)
                                                                </Box>
                                                                <Box className={`paymentOption ${this.state.selectedPaymentValue === "partialPayment" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("partialPayment") }}>
                                                                    Card (Partial)
                                                                </Box>
                                                                <Box className={`paymentOption ${this.state.selectedPaymentValue === "cash" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("cash") }}>
                                                                    Cash
                                                                </Box>
                                                                <Box className={`paymentOption ${this.state.selectedPaymentValue === "check" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("check") }}>
                                                                    Check / Money Order
                                                                </Box>
                                                                <Box className={`paymentOption ${this.state.selectedPaymentValue === "others" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("others") }}>
                                                                    Offline Payment method
                                                                </Box>
                                                                {this.state.paymentIntegration.name === 'CardConnect' || this.state.paymentIntegration.name === 'CardConnect_o' || this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o'
                                                                    ?
                                                                    <Box className={`paymentOption ${this.state.selectedPaymentValue === "ccPOS" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("ccPOS") }}>
                                                                        Terminal
                                                                    </Box>
                                                                    : null
                                                                }
                                                                <Box className={`paymentOption ${this.state.selectedPaymentValue === "checkoutPayment" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("checkoutPayment") }}>
                                                                    Pay at time of checkIn
                                                                </Box>
                                                            </>
                                                        }
                                                    </Box>
                                                    {(this.state.selectedPaymentValue === 'fullPayment' || this.state.selectedPaymentValue === 'partialPayment') && (!this.state.paymentIntegration.name.includes('Stripe'))
                                                        ? (
                                                            <>
                                                                {this.state.selectedPaymentValue === 'fullPayment'
                                                                    ? (
                                                                        <>
                                                                            {this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o'
                                                                                ?
                                                                                <>
                                                                                    <div className='rows'>
                                                                                        <Typography className='headings'>Amount</Typography>
                                                                                        <TextField id="paymentAmt" type="number"
                                                                                            className='resRight' value={this.state.totalAmount} disabled={true} variant='standard' />
                                                                                    </div>
                                                                                    <div className='rows'>
                                                                                        <Typography className='headings'>Service fees</Typography>
                                                                                        <TextField id="paymentAmt" type="number"
                                                                                            className='resRight' value={parseFloat(this.state.convenienceCharge).toFixed(2)} disabled={true} variant='standard' />
                                                                                    </div>
                                                                                    <div className='rows'>
                                                                                        <Typography className='headings'>Total</Typography>
                                                                                        <TextField id="paymentAmt" required type="number" className='resRight' disabled={true} variant='standard'
                                                                                            value={(parseFloat(this.state.totalAmount) + parseFloat(this.state.convenienceCharge)).toFixed(2)}
                                                                                        />
                                                                                    </div>
                                                                                    {this.state.last4 != null
                                                                                        ?
                                                                                        <div className='rows'>
                                                                                            <FormControlLabel
                                                                                                label={`Pay with card ending in: ${this.state.last4}`}
                                                                                                control={
                                                                                                    <GreenCheckbox
                                                                                                        id="payWithSavedCard"
                                                                                                        checked={this.state.payWithSavedCard}
                                                                                                        onChange={(e) => this.setState({ payWithSavedCard: e.target.checked })}
                                                                                                    />
                                                                                                }
                                                                                            />
                                                                                        </div>
                                                                                        : null
                                                                                    }
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    <div className='rows'>
                                                                                        <Typography className='headings'>Total</Typography>
                                                                                        <TextField id="paymentAmt" required type="number" className='resRight' disabled={true} variant='standard'
                                                                                            value={parseFloat(this.state.totalAmount).toFixed(2)}
                                                                                        />
                                                                                    </div>
                                                                                </>
                                                                            }

                                                                        </>
                                                                    )
                                                                    : (
                                                                        <>
                                                                            {this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o'
                                                                                ?
                                                                                <>
                                                                                    <div className='rows'>
                                                                                        <Typography className='headings'>Amount</Typography>
                                                                                        <TextField id="paymentAmt" required type="number"
                                                                                            className='resRight' value={this.state.partialBase} onChange={this.amountChange} />
                                                                                    </div>
                                                                                    <div className='rows'>
                                                                                        <Typography className='headings'>Service fees</Typography>
                                                                                        <TextField id="paymentAmt" type="number"
                                                                                            className='resRight' value={parseFloat(this.state.convenienceCharge).toFixed(2)} disabled={true} variant='standard' />
                                                                                    </div>
                                                                                    <div className='rows'>
                                                                                        <Typography className='headings'>Total</Typography>
                                                                                        <TextField id="paymentAmt" type="number"
                                                                                            className='resRight' value={parseFloat(this.state.partialTotal).toFixed(2)} disabled={true} variant='standard' />
                                                                                    </div>
                                                                                    {this.state.last4 != null
                                                                                        ?
                                                                                        <div className='rows'>
                                                                                            <FormControlLabel
                                                                                                label={`Pay with card ending in: ${this.state.last4}`}
                                                                                                control={
                                                                                                    <GreenCheckbox
                                                                                                        id="payWithSavedCard"
                                                                                                        checked={this.state.payWithSavedCard}
                                                                                                        onChange={(e) => this.setState({ payWithSavedCard: e.target.checked })}
                                                                                                    />
                                                                                                }
                                                                                            />
                                                                                        </div>
                                                                                        : null
                                                                                    }
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    <div className='rows'>
                                                                                        <Typography className='headings'>Amount</Typography>
                                                                                        <TextField id="paymentAmt" required label="Amount" type="number"
                                                                                            className='resRight' value={this.state.partialBase} onChange={this.amountChange} />
                                                                                    </div>
                                                                                </>
                                                                            }
                                                                        </>
                                                                    )
                                                                }
                                                                {this.state.payWithSavedCard
                                                                    ? null
                                                                    :
                                                                    <>
                                                                        <Typography className='typo'>Card Details</Typography>
                                                                        <hr className='horizontalLine' />
                                                                        <Box className='cardDetailsBox' style={{ marginBottom: "50px" }}>
                                                                            <Box style={{ display: 'flex', width: "85%" }}>
                                                                                <div className='row'>
                                                                                    <Typography className='typo'>Card Number</Typography>
                                                                                    <TextField
                                                                                        InputProps={{
                                                                                            startAdornment: <CreditCardIcon />
                                                                                        }}
                                                                                        id="cardNumber" required label="Card Number" type="number"
                                                                                        className='resRight' value={this.state.cardNumber} onChange={this.handlePaymentDetailsChange} />
                                                                                </div>

                                                                                <div className='row'>
                                                                                    <Typography className='typo'>Card Owner</Typography>
                                                                                    <TextField InputProps={{
                                                                                        startAdornment: <PersonIcon />
                                                                                    }} id="cardOwner" required label="Card Owner" type="text"
                                                                                        className='resRight' value={this.state.cardOwner} onChange={this.handlePaymentDetailsChange} />
                                                                                </div>
                                                                            </Box>
                                                                            <Box style={{ display: 'flex', marginTop: "30px" }}>
                                                                                <div className='expiryInputRow'>
                                                                                    <Typography className='typo'>Expiration Date</Typography>
                                                                                    <Box style={{ display: 'flex' }}>
                                                                                        <TextField style={{ width: "150px" }} InputProps={{
                                                                                            startAdornment: <TodayIcon />
                                                                                        }} id="expiryMonth" required label="MM" type="number" placeholder="MM"
                                                                                            className='expiryInput' value={this.state.expiryMonth} onChange={this.handlePaymentDetailsChange} />
                                                                                        <TextField style={{ width: "150px" }} InputProps={{
                                                                                            startAdornment: <DateRangeIcon />
                                                                                        }} id="expiryYear" required label="YY" type="number" placeholder="YY"
                                                                                            className='expiryInputYY' value={this.state.expiryYear} onChange={this.handlePaymentDetailsChange} />
                                                                                    </Box>
                                                                                </div>
                                                                                <div className='row' style={{ marginLeft: "50px" }}>
                                                                                    <Typography className='typo'>CVV</Typography>
                                                                                    <TextField style={{ width: "150px" }} InputProps={{
                                                                                        startAdornment: <KeyIcon />
                                                                                    }} id="cvv" required label="CVV" type="number"
                                                                                        className='cvvInput' value={this.state.cvv} onChange={this.handlePaymentDetailsChange} />
                                                                                </div>
                                                                            </Box>
                                                                        </Box>
                                                                        <div style={{ display: 'flex', justifyContent: 'center', justifyContent: 'center' }}>
                                                                            {this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o'
                                                                                ? <>
                                                                                    <ThemeProvider theme={theme} classes={{ paper: classes.dialogPaper }}>
                                                                                        <FormControlLabel
                                                                                            style={{ marginTop: '-2%' }}
                                                                                            label={"Save this card for future"}
                                                                                            control={
                                                                                                <GreenCheckbox
                                                                                                    id="saveCard"
                                                                                                    checked={this.state.saveCard}
                                                                                                    onChange={(event) => this.setState({ saveCard: event.target.checked, saveCardOnFileDialogue: true })}
                                                                                                />
                                                                                            }
                                                                                        />
                                                                                    </ThemeProvider>
                                                                                </>
                                                                                : null
                                                                            }
                                                                        </div>
                                                                    </>
                                                                }
                                                                <Button
                                                                    className='addButton'
                                                                    onClick={this.pay}
                                                                    disabled={!this.state.userDetailsFormValid}
                                                                >
                                                                    Pay
                                                                </Button>
                                                            </>
                                                        )
                                                        : null

                                                    }
                                                    {(this.state.selectedPaymentValue === 'fullPayment' || this.state.selectedPaymentValue === 'partialPayment') && (this.state.paymentIntegration.name === 'Stripe_o' || this.state.paymentIntegration.name === 'Stripe')
                                                    ? (
                                                        <>
                                                            {this.state.selectedPaymentValue === 'fullPayment'
                                                                ? (
                                                                    <>
                                                                        <div className='rows'>
                                                                            <Typography className='headings'>Amount to be paid</Typography>
                                                                            <TextField id="paymentAmt" required label="Amount" type="number"
                                                                                className='resRight' value={parseFloat(this.state.totalAmount).toFixed(2)} disabled={true} variant='standard' />
                                                                        </div>
                                                                        {this.state.paymentIntegration.name === 'Stripe' || this.state.paymentIntegration.name === 'Stripe_o'
                                                                            ?
                                                                            <div style={{width:'90%'}}>
                                                                                <StripePayment
                                                                                amount={this.state.totalAmount}
                                                                                connectedAccountId={this.state.paymentIntegration.stripe_account_id}
                                                                                onPaymentSuccess={this.handleStripeSuccess}
                                                                                handleStripeFail={this.handleStripeFail}
                                                                                billingDetails={{
                                                                                    name: `${this.state.fname} ${this.state.lname}`,
                                                                                    email: this.state.emailId,
                                                                                    phone: this.state.phoneNumber,
                                                                                    address: {
                                                                                        line1: this.state.address,
                                                                                        city: this.state.city,
                                                                                        state: this.state.state,
                                                                                        postal_code: this.state.zip,
                                                                                        country: 'US',
                                                                                    },
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                            : null
                                                                        }
                                                                    </>
                                                                )
                                                                : (
                                                                    <>
                                                                        {this.state.paymentIntegration.name === 'Stripe' || this.state.paymentIntegration.name === 'Stripe_o'
                                                                            ?
                                                                            <>
                                                                                <div className='rows'>
                                                                                    <Typography className='headings'>Amount to be paid</Typography>
                                                                                    <TextField id="paymentAmt" required label="Amount" type="number"
                                                                                        className='resRight' value={this.state.partialTotal} onChange={this.amountChange} />
                                                                                </div>
                                                                                <StripePayment
                                                                                amount={this.state.partialTotal}
                                                                                connectedAccountId={this.state.paymentIntegration.stripe_account_id}
                                                                                onPaymentSuccess={this.handleStripeSuccess}
                                                                                handleStripeFail={this.handleStripeFail}
                                                                                billingDetails={{
                                                                                    name: `${this.state.fname} ${this.state.lname}`,
                                                                                    email: this.state.emailId,
                                                                                    phone: this.state.phoneNumber,
                                                                                    address: {
                                                                                        line1: this.state.address,
                                                                                        city: this.state.city,
                                                                                        state: this.state.state,
                                                                                        postal_code: this.state.zip,
                                                                                        country: 'US',
                                                                                    },
                                                                                    }}
                                                                                />
                                                                            </>
                                                                            :
                                                                            null
                                                                        }
                                                                    </>
                                                                )
                                                            }
                                                        </>
                                                    )
                                                    : null
                                                }    
                                                    {this.state.selectedPaymentValue === 'cash' || this.state.selectedPaymentValue === 'check'
                                                        ?
                                                        <>
                                                            {this.state.selectedPaymentValue === 'cash'
                                                                ?
                                                                <>
                                                                    <div className='rows'>
                                                                        <Typography className='headings'>Cash Amount</Typography>
                                                                        <TextField id="cashAmount" required label="Amount" type="number"
                                                                            className='resRight' onChange={this.amountChange} />
                                                                    </div>
                                                                    <div className='rows'>
                                                                        <Typography className='headings'>Date</Typography>
                                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                            <DatePicker
                                                                                id='cashDate'
                                                                                label='Cash Date*'
                                                                                className='date'
                                                                                onChange={(date) => {
                                                                                    this.setState({ cashDate: date }, () => {
                                                                                        this.userDetailsValidation();
                                                                                    })
                                                                                }}
                                                                            />
                                                                        </LocalizationProvider>
                                                                    </div>
                                                                    <div className='rows'>
                                                                        <Button
                                                                            className='addButton'
                                                                            onClick={this.pay}
                                                                            disabled={!this.state.userDetailsFormValid}
                                                                        >
                                                                            Pay
                                                                        </Button>
                                                                    </div>
                                                                </>
                                                                :
                                                                <>
                                                                    <div className='rows'>
                                                                        <Typography className='headings'>Check Amount</Typography>
                                                                        <TextField id="checkAmount" required label="Amount" type="number"
                                                                            className='resRight' onChange={this.amountChange} />
                                                                    </div>
                                                                    <div className='rows'>
                                                                        <Typography className='headings'>Check Number</Typography>
                                                                        <TextField id="checkNumber" required label="Number" type="number"
                                                                            className='resRight' onChange={this.amountChange} />
                                                                    </div>
                                                                    <div className='rows'>
                                                                        <Typography className='headings'>Memo</Typography>
                                                                        <TextField id="memo" required label="Memo" type="text"
                                                                            className='resRight' onChange={this.amountChange} />
                                                                    </div>
                                                                    <div className='rows'>
                                                                        <Typography className='headings'>Date</Typography>
                                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                            <DatePicker
                                                                                id='checkDate'
                                                                                label='Check Date*'
                                                                                className='date'
                                                                                onChange={(date) => {
                                                                                    this.setState({ checkDate: date }, () => {
                                                                                        this.userDetailsValidation();
                                                                                    })
                                                                                }}
                                                                            />
                                                                        </LocalizationProvider>
                                                                    </div>
                                                                    <div className='rows'>
                                                                        <Button
                                                                            className='addButton'
                                                                            onClick={this.pay}
                                                                            disabled={!this.state.userDetailsFormValid}
                                                                        >
                                                                            Pay
                                                                        </Button>
                                                                    </div>
                                                                </>}
                                                        </>

                                                        : null
                                                    }
                                                    {this.state.selectedPaymentValue === 'ccPOS'
                                                        ?
                                                        <>
                                                            <div className='rows'>
                                                                <Typography className='headings'>Amount to be paid</Typography>
                                                                <TextField id="ccPOSAmount" required label="Amount" type="number"
                                                                    className='resRight' value={this.state.ccPOSAmount} onChange={this.amountChange} />
                                                            </div>
                                                            <div className='rows'>
                                                                <Button
                                                                    className='addButton'
                                                                    onClick={this.pay}
                                                                    disabled={!this.state.userDetailsFormValid}
                                                                >
                                                                    Pay
                                                                </Button>
                                                            </div>
                                                        </>
                                                        : null
                                                    }
                                                    {this.state.selectedPaymentValue === 'checkoutPayment'
                                                        ?
                                                        <>
                                                            <Button
                                                                className='addButton'
                                                                style={{ whiteSpace: "nowrap", width: "200px" }}
                                                                onClick={this.pay}
                                                                disabled={!this.state.userDetailsFormValid}
                                                            >
                                                                Complete Reservation
                                                            </Button>
                                                        </>
                                                        : null
                                                    }
                                                    {this.state.selectedPaymentValue === 'others'
                                                    ?
                                                    <>
                                                        <div className='rows'>
                                                            <Typography className='headings'>Amount</Typography>
                                                            <TextField id="offlineAmount" required label="Amount" type="number" value={this.state.offlineAmount}
                                                                className='resRight' onChange={this.amountChange} inputProps={{min: 0}} />
                                                        </div>
                                                        <div className='rows'>
                                                            <Typography className='headings'>Method</Typography>
                                                            <Select
                                                            style={{ width: "75%", textAlign: 'left', boxShadow: 'none' }}
                                                            id="offlineMethod"
                                                            value={this.state.offlineMethod || ''}
                                                            label="Select Method"
                                                            disabled={this.props.viewItem?.archived}
                                                            required
                                                            onChange={this.offlineMethodChange}
                                                            >
                                                            {methods.map((method, index) => (
                                                                <MenuItem key={index} value={method}>
                                                                    {method}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        </div>
                                                        <div className='rows'>
                                                            <Typography className='headings'>Reference Number</Typography>
                                                            <TextField id="offlineMemo" label="Memo" type="text" value={this.state.offlineMemo}
                                                                className='resRight' onChange={this.amountChange} />
                                                        </div>
                                                        <div className='rows'>
                                                            <Typography className='headings'>Last 4 of credit card</Typography>
                                                            <TextField id="offlineLast4" label="Last 4" type="number" value={this.state.offlineLast4}
                                                                className='resRight' onChange={this.amountChange} inputProps={{min: 0,max: 9999,maxLength: 4}}/>
                                                        </div>
                                                        <div className='rows'>
                                                            <Typography className='headings'>Date</Typography>
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    id='offlinePaymentDate'
                                                                    label='Date*'
                                                                    className='date'
                                                                    onChange={(date) => {
                                                                        this.setState({ offlinePaymentDate: date }, () => {
                                                                            this.userDetailsValidation();
                                                                        })
                                                                    }}
                                                                />
                                                            </LocalizationProvider>
                                                        </div>
                                                        <div className='rows'>
                                                            <Button
                                                                className='addButton'
                                                                onClick={this.pay}
                                                                disabled={!this.state.userDetailsFormValid}
                                                            >
                                                                Pay
                                                            </Button>
                                                        </div>
                                                    </>
                                                    : null
                                                }
                                                </ThemeProvider>
                                            </Box>

                                        </Box>
                                        <Box className='rightRow'>
                                            <Box className='bookingDetails' style={{ marginBottom: '7%' }}>
                                                <Typography className='typo'>Discounts</Typography>
                                                <hr className='horizontalLine' />
                                                <Box className='bookingRow' >
                                                    <ThemeProvider theme={theme}>
                                                        <Box style={{ marginBottom: '7%' }}>
                                                            <Typography className='bookingLabel'>One-Time Discount</Typography>
                                                        </Box>
                                                        <Box style={{ justifyContent: 'end', marginBottom: '7%' }}>
                                                            <TextField style={{ width: '100%', marginRight: '-20%' }} onChange={this.addOneTimeDiscount}
                                                                id="oneTimeDiscount" type="number"
                                                                // inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                                                inputProps={{ step: "any", min: "0" }}
                                                                //  value={this.state.oneTimeDiscount}
                                                                defaultValue={0}
                                                            />
                                                        </Box>
                                                    </ThemeProvider>
                                                </Box>
                                            </Box>

                                            <Box className='bookingDetails' style={{ marginBottom: '7%' }}>
                                                <Typography className='bookingTypo'>Booking Details</Typography>
                                                <hr className='horizontalLine' />
                                                <Box className='bookingRow'>
                                                    <Box>
                                                        <DateRangeIcon />
                                                        <Typography className='bookingLabel'>{this.props.checkIn}</Typography>
                                                    </Box>
                                                    <TrendingFlatIcon />
                                                    <Box className='checkout'>
                                                        <DateRangeIcon />
                                                        <Typography className='bookingValue'>{this.props.checkOut}</Typography>
                                                    </Box>
                                                </Box>
                                                <Box className='bookingRow'>
                                                    <Box>
                                                        <GroupIcon />
                                                        <Typography className='bookingLabel'>Adults</Typography>
                                                    </Box>
                                                    <Typography className='bookingValue'>{this.props.guests}</Typography>
                                                </Box>
                                                <Box className='bookingRow'>
                                                    <Box>
                                                        <PetsIcon />
                                                        <Typography className='bookingLabel'>Pets</Typography>
                                                    </Box>
                                                    <Typography className='bookingValue'>{this.props.pets}</Typography>
                                                </Box>
                                                {this.props.rigLength && <Box className='bookingRow'>
                                                    <Box>
                                                    <img src={measuring} width="30px" />
                                                        <Typography className='bookingLabel'>Rig Length</Typography>
                                                    </Box>
                                                    <Typography className='bookingValue'>{this.props.rigLength}</Typography>
                                                </Box>}
                                                {this.props.slides && <Box className='bookingRow'>
                                                    <Box>
                                                    <img src={rv} width="30px" />
                                                        <Typography className='bookingLabel'>Slides</Typography>
                                                    </Box>
                                                    <Typography className='bookingValue'>{this.props.slides}</Typography>
                                                </Box>}
                                                <hr className='horizontalLine' />
                                                <Box className='bookingRow'>
                                                    <Typography className='bookingLabel'>Site Name</Typography>
                                                    <Typography className='bookingValue'>{this.props.spaceName}</Typography>
                                                </Box>
                                                <Box className='bookingRow'>
                                                    <Typography className='bookingLabel'>Site Type</Typography>
                                                    <Typography className='bookingValue'>{this.props.siteType}</Typography>
                                                </Box>
                                                {this.state.blended && <Box className='bookingRow'>
                                                    <Typography className='bookingLabel'> </Typography>
                                                    <Typography className='bookingValue' style={{ fontWeight: 'bold' }}>Blended Rate</Typography>
                                                </Box>}
                                                {this.props.seasonBooking
                                                    ?
                                                    <>
                                                        <Box className='bookingRow'>
                                                            <Typography className='bookingLabel'>Seasonal</Typography>
                                                            <Typography className='bookingValue'>${parseFloat(this.state.seasonTotal).toFixed(2)}</Typography>
                                                        </Box>
                                                    </>
                                                    :
                                                    <>
                                                        {this.state.months > 0
                                                            ? <Box className='bookingRow'>
                                                                <Typography className='bookingLabel'>Months Total ({this.state.months})</Typography>
                                                                <Typography className='bookingValue'>${parseFloat(this.state.monthsTotal).toFixed(2)}</Typography>
                                                            </Box>
                                                            : null
                                                        }
                                                        {this.state.weeks > 0
                                                            ? <Box className='bookingRow'>
                                                                <Typography className='bookingLabel'>Weeks Total ({this.state.weeks})</Typography>
                                                                <Typography className='bookingValue'>${parseFloat(this.state.weeksTotal).toFixed(2)}</Typography>
                                                            </Box>
                                                            : null
                                                        }
                                                        {this.state.days > 0
                                                            ? <Box className='bookingRow'>
                                                                <Typography className='bookingLabel'>Days Total ({this.state.days})</Typography>
                                                                <Typography className='bookingValue'>${parseFloat(this.state.daysTotal).toFixed(2)}</Typography>
                                                            </Box>
                                                            : null
                                                        }
                                                    </>}
                                                {this.state.discountTotal != null
                                                    ? <Box className='bookingRow'>
                                                        {this.state.discountByPercent
                                                            ?
                                                            <Typography className='bookingLabel'>Discount ({this.props.discountPercent}%)</Typography>
                                                            :
                                                            <Typography className='bookingLabel'>Discount </Typography>
                                                        }
                                                        <Typography className='bookingValue'>${parseFloat(this.state.discountTotal).toFixed(2)}</Typography>
                                                    </Box>
                                                    : null
                                                }
                                                {this.state.oneTimeDiscount > 0.00
                                                    ? <Box className='bookingRow'>
                                                        <Typography className='bookingLabel'>One-Time Discount</Typography>
                                                        <Typography className='bookingValue'>${parseFloat(this.state.oneTimeDiscount).toFixed(2)}</Typography>
                                                    </Box>
                                                    : null
                                                }
                                                {Array.isArray(this.state.selectedExtras) && this.state.selectedExtras.length > 0
                                                    ? <>
                                                        {this.state.selectedExtras.map((extraName, index) => (
                                                            <Box className='bookingRow' key={index}>
                                                                <Typography className='bookingLabel'>{extraName} ({this.state.selectedExtraCount[index]})</Typography>
                                                                <Typography className='bookingValue'>${parseFloat(this.state.selectedExtraAmount[index]).toFixed(2)}</Typography>
                                                            </Box>
                                                        ))}
                                                    </>
                                                    : null
                                                }
                                                <hr className='horizontalLine' />
                                                <Box className='bookingRow'>
                                                    <Typography className='bookingLabel' style={{ fontWeight: 'bold' }}>{this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? 'Gross Total' : 'Sub Total'}</Typography>
                                                    <Typography className='bookingValue' style={{ fontWeight: 'bold' }}>${parseFloat(this.state.subTotal).toFixed(2)}</Typography>
                                                </Box>
                                                <hr className='horizontalLine' />
                                                {this.state.taxName.map((taxName, index) => (
                                                    <Box className='bookingRow' key={index}>
                                                        <Typography className='bookingLabel'>{taxName} ({this.state.taxPercent[index]}%)</Typography>
                                                        <Typography className='bookingValue'>${this.state.tax[index]}</Typography>
                                                    </Box>
                                                ))}
                                                {this.state.variableCharges.length > 0
                                                    ?
                                                    <>
                                                        <hr className='horizontalLine' />
                                                        {this.state.variableCharges.map((variableCharge, index) => (
                                                            <Box className='bookingRow'>
                                                                <Typography className='bookingLabel'>{variableCharge.detail}</Typography>
                                                                <Typography className='bookingValue'>${parseFloat(variableCharge.amount).toFixed(2)}</Typography>
                                                            </Box>
                                                        ))}
                                                        {/* <Box className='bookingRow'>
                                                    <Typography className='bookingLabel'>Service Fees</Typography>
                                                    <Typography className='bookingValue'>${parseFloat(this.state.oldVariableCharge).toFixed(2)}</Typography>
                                                </Box> */}
                                                    </>
                                                    : null
                                                }
                                                <hr className='horizontalLine' />

                                                <Box className='bookingRow'>
                                                    <Typography className='bookingLabel' style={{ fontWeight: 'bold' }}>{this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? 'Net Total' : 'Total'}</Typography>
                                                    <Typography className='bookingValue' style={{ fontWeight: 'bold' }}>${parseFloat(this.state.totalAmount).toFixed(2)}</Typography>
                                                </Box>
                                                {this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o'
                                                    ?
                                                    <>
                                                        <hr className='horizontalLine' />
                                                        <Box className='bookingRow'>
                                                            <Typography className='bookingLabel' >Service Fees</Typography>
                                                            <Typography className='bookingValue' >${parseFloat(this.state.convenienceCharge).toFixed(2)}</Typography>
                                                        </Box>

                                                        <hr className='horizontalLine' />
                                                        <Box className='bookingRow'>
                                                            <Typography className='bookingLabel' style={{ fontWeight: 'bold' }}>Total</Typography>
                                                            <Typography className='bookingValue' style={{ fontWeight: 'bold' }}>${(parseFloat(this.state.totalAmount) + parseFloat(this.state.convenienceCharge)).toFixed(2)}</Typography>
                                                        </Box>
                                                    </>
                                                    : null
                                                }
                                            </Box>

                                            {this.state.blended &&
                                                <Box className='bookingDetails' style={{ marginBottom: '7%' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <Typography className='typo'>Blended Rates Info</Typography>
                                                    </div>
                                                    <hr className='horizontalLine' />
                                                    <ThemeProvider theme={theme}>
                                                        <div style={{ overflowX: 'scroll' }}>
                                                            <Box sx={{ width: '130%' }}>
                                                                <Grid container spacing={3} style={{ padding: '10px' }}>
                                                                    <Grid item xs={3}>
                                                                        <Typography className="bookingLabel" style={{ fontWeight: 'bold', fontSize: '15px' }}>Start</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={3}>
                                                                        <Typography className="bookingLabel" style={{ fontWeight: 'bold', fontSize: '15px' }}>End</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={2}>
                                                                        <Typography className="bookingLabel" style={{ fontWeight: 'bold', fontSize: '15px' }}>Count</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={2}>
                                                                        <Typography className="bookingLabel" style={{ fontWeight: 'bold', fontSize: '15px' }}>Season</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={2}>
                                                                        <Typography className="bookingLabel" style={{ fontWeight: 'bold', fontSize: '15px' }}>Amount</Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            </Box>
                                                            {this.state.monthChunks?.length && <h5 style={{ textAlign: 'left', margin: '10px 15px' }}>Months</h5>}
                                                            {this.state.monthChunks?.length
                                                                && this.state.monthChunks.map(monthchunk =>
                                                                    <Box style={{ width: '130%' }}>
                                                                        <Grid container spacing={3} >
                                                                            <Grid item xs={2}>
                                                                                <Typography style={{ fontSize: '13px' }}>{monthchunk.from}</Typography>
                                                                            </Grid>
                                                                            <Grid item xs={3}>
                                                                                <Typography style={{ fontSize: '13px' }}>{monthchunk.to}</Typography>
                                                                            </Grid>
                                                                            <Grid item xs={3}>
                                                                                <Typography style={{ fontSize: '13px' }}>{monthchunk.months}</Typography>
                                                                            </Grid>
                                                                            <Grid item xs={2}>
                                                                                <Typography style={{ fontSize: '13px' }}>{monthchunk.season}</Typography>
                                                                            </Grid>
                                                                            <Grid item xs={2}>
                                                                                <Typography style={{ fontSize: '13px' }}>{monthchunk.cost}</Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Box>)
                                                            }
                                                            {this.state.weekChunks?.length && <h5 style={{ textAlign: 'left', margin: '10px 15px' }}>Weeks</h5>}
                                                            {this.state.weekChunks?.length
                                                                && this.state?.weekChunks.map(weekChunk =>
                                                                    <Box style={{ width: '130%' }}>
                                                                        <Grid container spacing={3} >
                                                                            <Grid item xs={3}>
                                                                                <Typography style={{ fontSize: '13px' }}>{weekChunk.from}</Typography>
                                                                            </Grid>
                                                                            <Grid item xs={3}>
                                                                                <Typography style={{ fontSize: '13px' }}>{weekChunk.to}</Typography>
                                                                            </Grid>
                                                                            <Grid item xs={2}>
                                                                                <Typography style={{ fontSize: '13px' }}>{weekChunk.weeks}</Typography>
                                                                            </Grid>
                                                                            <Grid item xs={2}>
                                                                                <Typography style={{ fontSize: '13px' }}>{weekChunk.season}</Typography>
                                                                            </Grid>
                                                                            <Grid item xs={2}>
                                                                                <Typography style={{ fontSize: '13px' }}>{weekChunk.cost}</Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Box>)
                                                            }
                                                            {this.state.dayChunks?.length && <h5 style={{ textAlign: 'left', margin: '10px 15px' }}>Days</h5>}
                                                            {(this.state.dayChunks?.length)
                                                                && this.state.dayChunks.map(dayChunk =>
                                                                    <Box style={{ width: '130%' }}>
                                                                        <Grid container spacing={3}>
                                                                            <Grid item xs={3}>
                                                                                <Typography style={{ fontSize: '13px' }}>{dayChunk.from}</Typography>
                                                                            </Grid>
                                                                            <Grid item xs={3}>
                                                                                <Typography style={{ fontSize: '13px' }}>{dayChunk.to}</Typography>
                                                                            </Grid>
                                                                            <Grid item xs={2}>
                                                                                <Typography style={{ fontSize: '13px' }}>1</Typography>
                                                                            </Grid>
                                                                            <Grid item xs={2}>
                                                                                <Typography style={{ fontSize: '13px' }}>{dayChunk.season}</Typography>
                                                                            </Grid>
                                                                            <Grid item xs={2}>
                                                                                <Typography style={{ fontSize: '13px' }}>{dayChunk.cost}</Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Box>)
                                                            }
                                                        </div>
                                                    </ThemeProvider>
                                                </Box>}

                                            <Box className='bookingDetails'>
                                                <Typography className='typo'>Internal Notes</Typography>
                                                <hr className='horizontalLine' />
                                                <ThemeProvider theme={theme}>
                                                    <textarea id="internalNotes" rows={15} onChange={this.userDetailsChange} value={this.state.internalNotes} style={{ width: '85%', marginBottom: '2%', whiteSpace: "pre-wrap", wordWrap: "break-word" }} />
                                                </ThemeProvider>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </>
                            : null
                        }
                    </>
                }
            </Grid>
        )
    };
};

export default withRouter(withStyles(useStyles)(NewReservationUserDetails));